import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDatabase, faLayerGroup, faTag,
  faServer//, faAsterisk, faChartPie, faList, faChartArea, faFileAlt, faProjectDiagram, faLongArrowAltUp, faEllipsisV
} from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import Load from '../components/loadAction';
import { convertDataForListView, getConvertedSize, getChartFilterData, getChartTypeForMonitorCharts, normalizeChartData, filterBoxPlotData } from "../utils/common_utils";
import { getAttributeData } from "../utils/event_handling";
import {
  DQ_CHART_POINTS,
  MIN_MAX_SCALE, REQUIRES_CONTRIBUTION_INSTEAD_OF_CHART, BUTTON_WAIT_TIME, DUPLICATE_METRIC
} from "../utils/constant";
import Image from '../components/image';
// import Summary from "./summary";
import moment from "moment";
import _ from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars';
// import Dropdown from 'react-bootstrap/Dropdown';
import { getApi//, postUIlogs
} from "../utils/event_handling";
import {getIconforMetrics,getTeamId,getUserId} from '../utils/common_utils';
import {normalizeChildDatasetName,normalizeAttributeName} from '../utils/attribute_name_utils';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'rc-tooltip';
// import Popover from 'react-bootstrap/Popover';
// Sample Tree Node Data
/*
const initialTreeData = [
  {
    id: 1,
    label: "Clustering",
    children: [
      {
        id: 2,
        label: "serving_data.csv",
        children: [
          {
            id: 3,
            label: "Metrics",
            children: [
              { id: 4, label: "Custom Metrics", children: [] },
              {
                id: 5,
                label: "Outcome",
                children: [],
              },
              {
                id: 6,
                label: "Age",
                children: [
                  {
                    id: 7,
                    label: "Metrics",
                    children: [
                      { id: 8, label: "Fill Rate", status: "up", value: "23 145" },
                      { id: 9, label: "Data Drift", status: "up", value: "23 145" },
                      { id: 10, label: "Data Outlier", status: "up", value: "23 145" },
                      { id: 11, label: "Custom Metrics", children: [] },
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 12,
            label: "DiabetesPedigreeFunction",
            children: [],
          },
          { id: 13, label: "BMI", children: [] },
          { id: 14, label: "Insulin", children: [] },
          { id: 15, label: "SkinThickness", children: [] },
        ],
      },
    ],
  },
];
*/
// class TreeNode extends Component {
//   constructor(props) {
//     super(props);
//     const { node, defaultExpandedId } = this.props;

//     this.state = {
//       expanded: node.id === defaultExpandedId,
//       children: node.children || [], // Ensure children is always an array
//       isLoading: false,
//     };
//   }

//   handleExpand = async () => {
//     const { expanded } = this.state;
//     const { node } = this.props;

//     if (expanded) {
//       this.setState({ expanded: false });
//     } else {
//       this.setState({ isLoading: true });
//       const newChildren = await this.loadChildren(node.id);
//       this.setState({
//         expanded: true,
//         children: newChildren,
//         isLoading: false,
//       });
//     }
//   };

//   loadChildren = async (nodeId) => {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         resolve([
//           { id: `${nodeId}-child-1`, label: `Child 1 of Node ${nodeId}` },
//           { id: `${nodeId}-child-2`, label: `Child 2 of Node ${nodeId}` },
//         ]);
//       }, 1000);
//     });
//   };

//   render() {
//     const { node, defaultExpandedId } = this.props;
//     const { expanded, children, isLoading } = this.state;

//     return (
//       <div className="tree-node">
//         <div
//           className="tree-node-label"
//           onClick={this.handleExpand}
//           style={{ cursor: "pointer" }}
//         >
//           {children.length > 0 && ( // Ensure children is always checked safely
//             <span style={{ marginRight: "5px" }}>
//               {expanded ? "▼" : "▶"}
//             </span>
//           )}
//           {node.label}
//         </div>
//         {isLoading && <div style={{ marginLeft: "20px" }}>Loading...</div>}
//         {expanded && (
//           <div style={{ marginLeft: "20px" }}>
//             {children.map((child) => (
//               <TreeNode
//                 key={child.id}
//                 node={child}
//                 defaultExpandedId={defaultExpandedId}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   }
// }


// class TreeView extends Component {
//   render() {
//     const { data, defaultExpandedId } = this.props;
//     return (
//       <div className="tree-view">
//         {data.map((node) => (
//           <TreeNode
//             key={node.id}
//             node={node}
//             defaultExpandedId={defaultExpandedId}
//           />
//         ))}
//       </div>
//     );
//   }
// }



let activeItem = {
  'Attribute': 'breadcrumb-item',
  'Dataset': 'breadcrumb-item',
  'Datasource': 'breadcrumb-item',
  'Environment': 'breadcrumb-item',

};

document.onkeydown = checkKey;
function checkKey(e) {
  e = e || window.event;
  let downClick = document.getElementById("down")
  if (downClick === null) {
    return
  }
  if (e.keyCode === 38) {
    // up arrow
    //document.getElementById("up").click();
    start("up");
  }
  else if (e.keyCode === 40) {
    // down arrow

    start("down");
    //document.getElementById("down").click();
  }

}

let funCallFlag;
function start(param) {
  if (funCallFlag !== "undefined") {
    clearInterval(funCallFlag);
  }
  if (param === "up") {

    funCallFlag = setInterval(upButtonClick, BUTTON_WAIT_TIME);
  } else {
    funCallFlag = setInterval(downButtonClick, BUTTON_WAIT_TIME);
  }

}

function upButtonClick(e) {
  document.getElementById("up").click();
  clearInterval(funCallFlag);
}

function downButtonClick(e) {
  document.getElementById("down").click();
  clearInterval(funCallFlag);
}


class RealTimeLeftPanel extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.changeTab = this.changeTab.bind(this);
    this.changeSource = this.changeSource.bind(this);
    this.getChartFilterData = getChartFilterData.bind(this);
    this.changeData = this.changeData.bind(this);
    this.breadCrumbEvent = this.breadCrumbEvent.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
    this.handleTreeViewButton = this.handleTreeViewButton.bind(this);
    this.processDatasourceChart = this.processDatasourceChart.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeIcon = this.closeIcon.bind(this);
    this.getAttributeData = getAttributeData.bind(this);
    this.getEnvTableData = this.getEnvTableData.bind(this);
    this.reset = this.reset.bind(this);
    let initialSelection = this.props.initialSelection
    // let nestedData = this.props.nestedData
    let startDate = moment().subtract(30, 'days');
    let endDate = moment().endOf('day');
    this.getApi = getApi.bind(this);
    this.state = {
      activeTabKey: "chartView",
      businessRule: null,
      sectionName: "",
      dataType: null,
      outlier: null,
      envTableData: null,
      recencyData: 0,
      disableDown: false,
      disableUp: true,
      distributionData: null,
      profileData: null,
      datasetIds: [],
      startDate: startDate,
      endDate: endDate,
      newData: {},
      isTreeSearch: false,
      datasetRow: 0,
      duplicateRows: 0,
      isRedirect: this.props.isRedirect,
      isFetched: false,
      filteredData: null,
      datasourceCount: 0,
      // data: nestedData,
      filterSearch: "",
      subString: this.props.subString,
      lastRefresh: null,
      attributeCount: 0,
      datasetCount: 0,
      isSearchHappened: this.props.isSearchHappened,
      selectedDataSource: null,
      isChartChanged: false,
      driftOnMetricsChart: null,
      selectedData: [],
      isDataChanged: false,
      currentIndex: 0,
      highlightedType: "",
      highlightedId: null,
      showTreeView: false,
      metricsOptions: [],
      envName: initialSelection.envName,
      datasourceName: initialSelection.datasourceName,
      datasetName: initialSelection.datasetName,
      attributeName: initialSelection.attributeName,
      filteredValues: [],
      driftOnMetricsKey: null,
      showCustomCheckbox: this.props.showCustomCheckbox,
      isNodeHasActions: this.props.isNodeHasActions,
      showSearchFilter: this.props.showSearchFilter,
      data:this.props.integrations_data,
      isChecked:this.props.isChecked,
      handleCheckboxChange: this.props.handleCheckboxChange,
      arrowIndicator:this.props.arrowIndicator,
      newValue :this.props.newValue,
      oldValue :this.props.oldValue,
      leftSearchText:'',
      loading: true, // Initial loading state
      teamId:getTeamId(),
      userId:getUserId(),
      selectedEnvId : this.props.selectedEnvId,
      selectedWatchListId : this.props.selectedWatchListId,
      AllInterationsResponse:this.props.AllInterationsResponse
    }
  }
  changeTab(tab) {
    this.setState({ activeTabKey: tab });
  }
  handleLoad(value) {
    this.setState({ loadValue: value });
  }
  findAverage(inputArr) {
    if (inputArr !== null && inputArr !== undefined) {
      return inputArr.reduce((a, b) => a + b) / inputArr.length;
    } else {
      return 0;
    }
  }

  getEnvTableData(envData, chartData) {
    let headers = ["Datasource Name", "Dataset Name", "Attribute Count", "Dataset Size", "Last Refreshed Time"];
    let finalOp = [];
    let datasourceData = Object.values(envData)
    for (let i = 0; i < datasourceData.length; i++) {
      let datasourceName = datasourceData[i]["title"]
      let datasetData = Object.values(datasourceData[i]["childNodes"])
      for (let j = 0; j < datasetData.length; j++) {
        let row = [];
        let d = datasetData[j];
        let datasetName = d["title"]
        let datasetId = d["id"]
        let lastRefreshData = chartData.issued_attributes[datasetId]
        let sizeData = this.props.dataModule.dataSize.filter(x => x.data_set_id === Number(datasetId))
        let dataSize = 0
        if (sizeData.length > 0) {
          dataSize = getConvertedSize(sizeData[0]["size"])
        }
        let lastRefresh = null
        if (lastRefreshData) {
          lastRefresh = Object.values(lastRefreshData)[0]["refresh_time"]
        }

        let attributeCount = Object.values(d["childNodes"]).length

        row.push({ "value": datasourceName, "type": "td" });
        row.push({ "value": datasetName, "type": "td" });
        row.push({ "value": attributeCount, "type": "td" });
        row.push({ "value": dataSize, "type": "td" });
        row.push({ "value": lastRefresh, "type": "td" });
        finalOp.push(row);
      }
    }
    let tableData = { "headers": headers, "data": finalOp };

    return tableData;

  }
  changeSource(metricName, stateKey, title) {
    let finalData = null
    let filteredData = null
    if (this.state.selectedData !== null && ["Dataset", "Attribute"].includes(this.state.sectionName)) {
      for (let row of this.state.selectedData) {
        if (row["name"] === metricName) {
          finalData = row;
          finalData['data_source_name'] = this.state.datasourceName;
          finalData["datasetName"] = this.state.datasetName;
          finalData['attribute_name'] = this.state.attributeName;
          finalData['error_percentage'] = this.findAverage().toFixed(2);
          if (finalData["name"] === "Data Drift") {
            finalData["boxPlotData"] = filterBoxPlotData(finalData["boxPlotData"])
          }
          filteredData = getChartFilterData(finalData, this.state.startDate, this.state.endDate)
          break;
        }
      }
    } else if (this.state.sectionName === "Datasource") {
      let dataFromProps = this.props.datasourceData[metricName]
      let data = _.cloneDeep(dataFromProps);
      let result = this.processDatasourceChart(data, this.state.selectedDataSource)
      finalData = result["finalData"]
      filteredData = result["filteredData"]

    }


    const metricKey = "attribute_" + metricName;
    this.setState({ driftOnMetricsChart: finalData, filteredData: filteredData, loadValue: false, driftOnMetricsKey: metricKey });
  }
  componentDidMount() {
    this.loadingTimer = setTimeout(() => {
        this.setState({ loading: false });
    }, 3000); // Show loader for 3 seconds

    //  this.props.getMetricsValueResponse(this.props.id,this.props.selectedWatchlistId);

}

  componentWillUnmount() {
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
  }

  componentDidUpdate(prevProps) {


if (JSON.stringify(prevProps.AllInterationsResponse) !== JSON.stringify(this.props.AllInterationsResponse) && prevProps.selectedEnvId !== this.props.selectedEnvId && prevProps.metricsValueResponse !== this.props.metricsValueResponse ) {
  
  this.setState({ AllInterationsResponse: this.props.AllInterationsResponse });
  // this.props.getMetricsValueResponse(this.props.id,this.props.selectedWatchlistId,this.props.isPartitionChecked);
}
// if (JSON.stringify(prevProps.AllInterationsResponse) !== JSON.stringify(this.props.AllInterationsResponse)) {  
//   this.setState({ AllInterationsResponse: this.props.AllInterationsResponse });
// }

      if (
        prevProps.arrowIndicator !== this.props.arrowIndicator ||
        prevProps.newValue !== this.props.newValue ||
        prevProps.oldValue !== this.props.oldValue
      ) {
      }
    if (prevProps.nestedData !== this.props.nestedData) {
      let initialSelection = this.props.initialSelection
      let envId = initialSelection.envId
      let datasourceId = initialSelection.datasourceId
      let datasetId = initialSelection.datasetId
      let duplicateRows = 0;
      let attributeId = initialSelection.attributeId
      let filteredValues = [];
      let selectedData = []
      let metricData = []
      let metricsOptions = []
      let chartData = this.props.metricData;
      let sectionName = ""
      let driftOnMetricsChart = null
      let filteredData = null
      let driftOnMetricsKey = null
      let highlightedType = ""
      let highlightedId = null
      let prefix;
      let datasetIds = []
      let attributeCount = 0
      let datasetCount = 0
      let datasourceCount = 0
      let nestedData = this.props.nestedData
      let lastRefresh;
      let datasetRow = 0;
      let envTableData = null
      let recencyData = 0


      if (Object.keys(initialSelection).length !== 0) {
        envId = initialSelection.envId
        datasourceId = initialSelection.datasourceId
        highlightedType = initialSelection.type
        datasetId = initialSelection.datasetId
        attributeId = initialSelection.attributeId
        if (attributeId !== null && attributeId !== undefined) {
          prefix = `${envId}.${datasourceId}.${datasetId}.${attributeId}`
          metricData = Object.values(chartData.attribute_level_data[datasetId][attributeId])
          sectionName = "Attribute"
          this.setState({ isFetched: false });
          this.getAttributeData(datasetId, initialSelection.attributeName);
          highlightedId = attributeId
        } else if (datasetId !== null && datasetId !== undefined) {
          prefix = `${envId}.${datasourceId}.${datasetId}`;
          metricData = Object.values(chartData.dataset_level_data[datasetId])
          sectionName = "Dataset"
          lastRefresh = Object.values(chartData.issued_attributes[datasetId])[0]["refresh_time"]
          datasetIds = [datasetId]
          highlightedId = datasetId
          attributeCount = Object.values(nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"]).length
          let duplicateInfo = this.props.dataModule.info[datasourceId][prefix]
          if (duplicateInfo !== undefined) {
            let duplicateRowsList = duplicateInfo[`${DUPLICATE_METRIC}_duplicate_row`]
            if (duplicateRowsList) {
              duplicateRows = duplicateRowsList[duplicateRowsList.length - 1]
            }

          }
        } else if (datasourceId !== null && datasourceId !== undefined) {
          prefix = `${envId}.${datasourceId}`;
          sectionName = "Datasource"
          highlightedId = datasourceId
          datasetIds = Object.keys(nestedData[envId]["childNodes"][datasourceId]["childNodes"])
          datasetCount = datasetIds.length
          for (const key of Object.keys(this.props.datasourceData)) {
            if (key.includes("Data")) {
              metricsOptions.push({ "label": key, "value": key })
            }

          }
          if (metricsOptions.length > 0) {
            let dataFromProps = this.props.datasourceData[metricsOptions[0].value]
            let data = _.cloneDeep(dataFromProps);
            let result = this.processDatasourceChart(data, datasourceId);
            driftOnMetricsChart = result["finalData"]
            filteredData = result["filteredData"]
          }

          let recencyInfo = this.props.dataModule.recencyDetails[datasourceId]
          for (let value of Object.values(recencyInfo)) {
            let recencyFiltered = value
            let recencyList = recencyFiltered[`${DUPLICATE_METRIC}_time_value`]
            let latestRecency = 0
            if (recencyList) {
              latestRecency = recencyList[recencyList.length - 1]
            }
            if (latestRecency > 30) {
              recencyData = recencyData + 1
            }
          }
          let duplicateInfo = this.props.dataModule.info[datasourceId]
          for (let value of Object.values(duplicateInfo)) {
            let duplicateFiltered = value
            let duplicateRowsList = duplicateFiltered[`${DUPLICATE_METRIC}_duplicate_row`]
            if (duplicateRowsList) {
              duplicateRows = duplicateRowsList[duplicateRowsList.length - 1] + duplicateRows
            }
          }

        } else {
          prefix = `${envId}`;
          sectionName = "Environment"
          datasetCount = 0
          highlightedId = envId
          let total = nestedData[envId]["childNodes"]
          datasourceCount = Object.keys(total).length
          for (const value of Object.values(total)) {
            datasetIds = datasetIds.concat(Object.keys(value["childNodes"]))
            datasetCount = datasetCount + datasetIds.length

          }
          envTableData = this.getEnvTableData(nestedData[envId]["childNodes"], chartData)
        }
        metricData = convertDataForListView(metricData, initialSelection.datasetName, initialSelection.datasourceName)
        for (let i = 0; i < metricData.length; i++) {
          if (metricData[i]["name"] === "Row Count") {
            datasetRow = metricData[i]["value"][metricData[i]["value"].length - 1]
          }
          //           if(metricData[i]["hasDrift"] === false) {
          //             continue
          //           }
          selectedData.push(metricData[i]);
          metricsOptions.push({ "label": metricData[i]["name"], "value": metricData[i]["name"] })
        }
        if (selectedData.length > 0) {
          driftOnMetricsChart = selectedData[0]
          filteredData = getChartFilterData(driftOnMetricsChart, this.state.startDate, this.state.endDate)
          driftOnMetricsKey = sectionName + driftOnMetricsChart["name"]
        }
        filteredValues.push(prefix)

      }
      this.setState({
        data: this.props.nestedData,
        envName: initialSelection.envName,
        datasourceName: initialSelection.datasourceName,
        selectedDataSource: datasourceId,
        lastRefresh: lastRefresh,
        datasetRow: datasetRow,
        duplicateRows: duplicateRows,
        recencyData: recencyData,
        subString: this.props.subString,
        selectedData: selectedData,
        driftOnMetricsChart: driftOnMetricsChart,
        filteredData: filteredData,
        sectionName: sectionName,
        driftOnMetricsKey: driftOnMetricsKey,
        metricsOptions: metricsOptions,
        attributeCount: attributeCount,
        datasourceCount: datasourceCount,
        isTreeSearch: false,
        envTableData: envTableData,
        newData: {},
        filterSearch: "",
        datasetCount: datasetCount,
        datasetIds: datasetIds,
        highlightedId: highlightedId,
        highlightedType: highlightedType,
        isSearchHappened: this.props.isSearchHappened,
        datasetName: initialSelection.datasetName,
        isRedirect: this.props.isRedirect,
        attributeName: initialSelection.attributeName,
        filteredValues: filteredValues,
        envId: envId,
        datasetId: datasetId,
        attributeId: attributeId,
        isDataChanged: !this.state.isDataChanged,
        
      })
    }
  }
  getDefaultSelectedMetrics() {
    let selectedMetricOptions = [];
    if (this.state.metricsOptions.length > 0) {
      selectedMetricOptions = this.state.metricsOptions[0];
      return selectedMetricOptions;
    } else {
      return selectedMetricOptions;
    }
  }

  breadCrumbEvent(e) {
    let type = e.target.id
    if (this.state.highlightedType === type) {
      return
    }
    let envName = this.state.envName
    let datasourceName = this.state.datasourceName
    let datasetName = this.state.datasetName
    let attributeName = this.state.attributeName
    let envId = this.state.envId
    let datasourceId = this.state.selectedDataSource
    let datasetId = this.state.datasetId
    let attributeId = this.state.attributeId
    if (type === "Environment") {
      this.changeData(envName, "", "", "", envId, null,
        null, null, envId, type);
    } else if (type === "Datasource") {
      this.changeData(envName, datasourceName, "", "", envId, datasourceId,
        null, null, datasourceId, type);
    } else if (type === "Dataset") {
      this.changeData(envName, datasourceName, datasetName, "", envId, datasourceId,
        datasetId, null, datasetId, type);
    } else if (type === "Attribute") {
      this.changeData(envName, datasourceName, datasetName, attributeName, envId, datasourceId,
        datasetId, attributeId, attributeId, type);
    }




  }



  changeData(envName, datasourceName, datasetName, attributeName, envId, datasourceId,
    datasetId, attributeId, id, type,isOpen, currentIndex = null,title,isChild) {
      
      //Add condition only tree opens 
      if (!isOpen){
      this.props.renderchartView(envName, datasourceName, datasetName, attributeName, envId, datasourceId,
        datasetId, attributeId, id, type,currentIndex = null,title,isChild)
      }
    let filteredValues = [];
    let filteredData;
    let chartData = this.props.metricData;
    let driftOnMetricsChart = null
    let driftOnMetricsKey = null
    let selectedData = []
    let metricData = []
    let metricsOptions = []
    let prefix;
    let attributeCount;
    let datasetCount;
    let datasetIds = [];
    let envTableData = null
    let lastRefresh;
    let duplicateRows = 0;
    let recencyData = 0
    let datasourceCount;
    let sectionName = ""
    let originalData = _.cloneDeep(this.props.originalData);
    if (originalData[envId]) {
    if (attributeId !== null && attributeId !== undefined) {
      prefix = `${envId}.${datasourceId}.${datasetId}.${attributeId}`
      metricData = Object.values(chartData.attribute_level_data[datasetId][attributeId])
      sectionName = "Attribute"
      this.setState({ isFetched: false, distributionData: null });
      this.getAttributeData(datasetId, attributeName);
      originalData[envId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
    } else if (datasetId !== null && datasetId !== undefined) {
      originalData[envId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true

      prefix = `${envId}.${datasourceId}.${datasetId}`;
      lastRefresh = Object.values(chartData.issued_attributes[datasetId])[0]["refresh_time"]
      metricData = Object.values(chartData.dataset_level_data[datasetId])
      sectionName = "Dataset"
      datasetIds = [datasetId]
      let duplicateInfo = this.props.dataModule.info[datasourceId][prefix]
      if (duplicateInfo !== undefined) {
        let duplicateRowsList = duplicateInfo[`${DUPLICATE_METRIC}_duplicate_row`]
        if (duplicateRowsList) {
          duplicateRows = duplicateRowsList[duplicateRowsList.length - 1]
        }

      }
      attributeCount = Object.values(originalData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"]).length
    } else if (datasourceId !== null && datasourceId !== undefined) {
      prefix = `${envId}.${datasourceId}`;
      sectionName = "Datasource"
      datasetIds = Object.keys(originalData[envId]["childNodes"][datasourceId]["childNodes"])
      datasetCount = datasetIds.length
      originalData[envId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["isOpen"] = true
      originalData[envId]["childNodes"][datasourceId]["isShow"] = true
      for (const key of Object.keys(this.props.datasourceData)) {
        if (key.includes("Data")) {
          metricsOptions.push({ "label": key, "value": key })
        }

      }
      if (metricsOptions.length > 0) {
        let dataFromProps = this.props.datasourceData[metricsOptions[0].value]
        let data = _.cloneDeep(dataFromProps);
        let result = this.processDatasourceChart(data, datasourceId);
        driftOnMetricsChart = result["finalData"]
        filteredData = result["filteredData"]
      }

      let duplicateInfo = this.props.dataModule.info[datasourceId]
      for (let value of Object.values(duplicateInfo)) {
        let duplicateFiltered = value
        let duplicateRowsList = duplicateFiltered[`${DUPLICATE_METRIC}_duplicate_row`]
        if (duplicateRowsList) {
          duplicateRows = duplicateRowsList[duplicateRowsList.length - 1] + duplicateRows
        }
      }
      let recencyInfo = this.props.dataModule.recencyDetails[datasourceId]
      for (let value of Object.values(recencyInfo)) {
        let recencyFiltered = value
        let recencyList = recencyFiltered[`${DUPLICATE_METRIC}_time_value`]
        let latestRecency = 0
        if (recencyList) {
          latestRecency = recencyList[recencyList.length - 1]
        }
        if (latestRecency > 30) {
          recencyData = recencyData + 1
        }
      }

    } else {
      prefix = `${envId}`;
      sectionName = "Environment"
      datasetCount = 0
      let total = originalData[envId]["childNodes"]
      datasourceCount = Object.keys(total).length
      for (const value of Object.values(total)) {
        datasetIds = datasetIds.concat(Object.keys(value["childNodes"]))
        datasetCount = datasetCount + datasetIds.length
      }
      envTableData = this.getEnvTableData(originalData[envId]["childNodes"], chartData)
      originalData[envId]["isShow"] = true
      originalData[envId]["isOpen"] = true
    }}
    let datasetRow = 0;
    if (["Dataset", "Attribute"].includes(sectionName)) {
      metricData = convertDataForListView(metricData, datasetName, datasourceName)
      for (let i = 0; i < metricData.length; i++) {
        if (metricData[i]["name"] === "Row Count") {
          datasetRow = metricData[i]["value"][metricData[i]["value"].length - 1]
        }
        //               if(metricData[i]["hasDrift"] === false) {
        //                 continue
        //               }

        selectedData.push(metricData[i]);
        metricsOptions.push({ "label": metricData[i]["name"], "value": metricData[i]["name"] });
      }

    }

    if (selectedData.length > 0) {
      driftOnMetricsChart = selectedData[0]
      if (driftOnMetricsChart["name"] === "Data Drift") {
        driftOnMetricsChart["boxPlotData"] = filterBoxPlotData(chartData["boxPlotData"])
      }
      filteredData = getChartFilterData(driftOnMetricsChart, this.state.startDate, this.state.endDate, "", false, false, 10)
      driftOnMetricsKey = sectionName + driftOnMetricsChart["name"]
    }
    if (currentIndex === null) {
      let currentData = this.props.filteredData.filter(x => x.type === type && x.id === id)
      currentIndex = this.props.filteredData.indexOf(currentData[0])
    }

    filteredValues.push(prefix)
    if (this.state.isTreeSearch) {
      this.setState({ isTreeSearch: false, subString: "", filterSearch: "", newData: originalData, isDataChanged: !this.state.isDataChanged })
    }
    this.setState({
      envName: envName,
      currentIndex: currentIndex,
      envTableData: envTableData,
      filteredData: filteredData,
      selectedDataSource: datasourceId,
      datasetId: datasetId,
      recencyData: recencyData,
      envId: envId,
      duplicateRows: duplicateRows,
      attributeId: attributeId,
      datasetRow: datasetRow,
      selectedData: selectedData,
      lastRefresh: lastRefresh,
      showTreeView: false,
      metricsOptions: metricsOptions,
      sectionName: sectionName,
      datasetCount: datasetCount,
      attributeCount: attributeCount,
      datasourceCount: datasourceCount,
      isChartChanged: !this.state.isChartChanged,
      driftOnMetricsChart: driftOnMetricsChart,
      driftOnMetricsKey: driftOnMetricsKey,
      filteredValues: filteredValues,
      datasourceName: datasourceName,
      datasetName: datasetName,
      highlightedType: type,
      datasetIds: datasetIds,
      highlightedId: id,
      attributeName: attributeName
    })
  }
  processDatasourceChart(data, datasourceId) {
    let finalData = null;
    let filteredData = null;
    let attributeName = null;
    let datasetName = null;
    if (data !== undefined) {
      for (const [key, value] of Object.entries(data)) {
        for (const [attribute, chartDataValues] of Object.entries(value)) {
          const attributeKeysSplit = attribute.split(".");
          if (datasourceId !== null) {
            if (attributeKeysSplit[1] !== datasourceId) {
              continue;
            }
          }

          let metaData = this.props.metaData[attribute];
          if (metaData === undefined) {
            metaData = this.props.metaData;
            const filtered = Object.keys(metaData)
              .filter(key => key.startsWith(attribute))
              .reduce((obj, key) => {
                obj[key] = metaData[key];
                return obj;
              }, {});
            metaData = filtered[Object.keys(filtered)[0]];
            if (metaData !== undefined) {
              metaData = metaData.split(".").slice(0, metaData.split(".").length - 1).join(".");
            }
          }
          if (metaData !== undefined) {
            const metadataSplit = metaData.split(".");

            let toolTiptopHeader;
            let keysSplitLength = attributeKeysSplit.length;

            // Skip attribute level charts for consistency related metrics
            if (keysSplitLength === 4 && REQUIRES_CONTRIBUTION_INSTEAD_OF_CHART.includes(key)) {
              continue;
            }

            if (keysSplitLength === 4) {
              datasetName = metadataSplit[2];
              attributeName = metadataSplit[metadataSplit.length - 1];
              toolTiptopHeader = attributeName;
            } else {
              datasetName = metadataSplit[2];
              toolTiptopHeader = datasetName;
            }
            if (chartDataValues["name"] === "Data Drift") {
              let boxPlotData = {}
              let statistics = {}
              let quantile = chartDataValues["boxplot_data"]
              if (quantile !== undefined && quantile !== null) {
                statistics["attribute_name"] = attributeName
                statistics["quantile"] = quantile
                statistics["drift_patterns"] = chartDataValues["drift_patterns"]
                statistics["time"] = chartDataValues["time"]
                if (attributeName !== null) {
                  boxPlotData["chart_level"] = "Attribute"
                } else {
                  boxPlotData["chart_level"] = "Dataset"
                }
                boxPlotData["statistics"] = [statistics]
                chartDataValues["boxPlotData"] = boxPlotData
                chartDataValues["chartType"] = "boxPlotZoomable"
              }
            }
            if (attributeName !== null) {
              chartDataValues["attribute_name"] = attributeName;
            }
            chartDataValues["datasetName"] = datasetName;
            chartDataValues["toolTiptopHeader"] = toolTiptopHeader;
            chartDataValues["data_set_id"] = attributeKeysSplit[2];
            chartDataValues["errorChart"] = true;
            chartDataValues["title"] = `${metadataSplit.join(" > ")} - ${chartDataValues.name}`;
            chartDataValues["data_source_name"] = metadataSplit[1];
            chartDataValues[DQ_CHART_POINTS] = chartDataValues["value"];

            let chartTypeData = getChartTypeForMonitorCharts(chartDataValues);
            chartDataValues["type"] = chartTypeData.chartPatternType;
            let hasError = chartTypeData.hasError;
            chartDataValues["hasDrift"] = hasError;

            // We are changing scale of all charts to min max scale
            // Part of fix for issue 1038
            chartDataValues["scale"] = MIN_MAX_SCALE;



            normalizeChartData(chartDataValues, DQ_CHART_POINTS);
            let chartValues = chartDataValues[DQ_CHART_POINTS];
            let drift_len = chartValues.length;

            if (drift_len === 0) {
              continue;
            }

            if (drift_len > 1) {
              chartDataValues["error_percentage"] = chartValues[(drift_len - 1)].toFixed(2);
              chartDataValues["last_error"] = chartValues[(drift_len - 2)].toFixed(2);
            } else if (drift_len === 1) {
              chartDataValues["error_percentage"] = chartValues[(drift_len - 1)].toFixed(2);
              chartDataValues["last_error"] = chartValues[(drift_len - 1)].toFixed(2);
            } else {
              chartDataValues["error_percentage"] = 0;
              chartDataValues["last_error"] = 0;
            }


          }
          finalData = chartDataValues

          if (finalData !== null) {
            if (finalData["name"] === "Data Drift") {
              finalData["boxPlotData"] = filterBoxPlotData(finalData["boxPlotData"])
            }
            filteredData = getChartFilterData(finalData, this.state.startDate, this.state.endDate)
            this.setState({ chartDatasetName: datasetName, chartAttributeName: attributeName })
            break
          }
        }


        if (finalData !== null) {
          break
        }
      }
    }
    let result = { "finalData": finalData, "filteredData": filteredData }
    return result
  }
  closeIcon() {
    this.setState({ filterSearch: "", newData: {}, isDataChanged: !this.state.isDataChanged, isTreeSearch: false, subString: null });
  }

  handleChange = event => {
    let filterSearch = event.target.value
    this.setState({ filterSearch: filterSearch });

    const lowerCasedFilter = filterSearch.toLowerCase();
    if (lowerCasedFilter.length === 0 || !lowerCasedFilter.trim()) {
      this.setState({ newData: {}, isDataChanged: !this.state.isDataChanged, isTreeSearch: false, subString: null })
      return
    }
    let autoCompleteData = this.props.autoCompleteData
    let nestedData = _.cloneDeep(this.props.originalData)
    let newData = {}
    let searchTextFound = false
    
    for (let i = 0; i < autoCompleteData.length; i++) {
      let data = autoCompleteData[i]
      let type = data["type"]
      let name = data["name"] ? data["name"].toLowerCase() : ""
      if (!name.includes(lowerCasedFilter) || type === "Recent") {
        continue
      }
      searchTextFound = true

      let envId = data["envId"]
      let datasourceId = data["datasourceId"]
      let datasetId = data["datasetId"]
      let attributeId = data["attributeId"]
      
      // Add environment if not already added
      if (!Object.keys(newData).includes(envId)) {
        newData[envId] = _.cloneDeep(nestedData[envId])
        newData[envId]["isOpen"] = true
        newData[envId]["isShow"] = true
      }

      // Add/open datasource if present in search result
      if (datasourceId !== undefined) {
        if (newData[envId]["childNodes"] && newData[envId]["childNodes"][datasourceId]) {
          newData[envId]["childNodes"][datasourceId]["isOpen"] = true
          newData[envId]["childNodes"][datasourceId]["isShow"] = true
        }
      }

      // Add/open dataset if present in search result
      if (datasetId !== undefined) {
        if (newData[envId]["childNodes"] && newData[envId]["childNodes"][datasourceId] && 
            newData[envId]["childNodes"][datasourceId]["childNodes"] && 
            newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]) {
          newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isOpen"] = true
          newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["isShow"] = true
        }
      }

      // Add/open attribute if present in search result
      if (attributeId !== undefined) {
        if (newData[envId]["childNodes"] && newData[envId]["childNodes"][datasourceId] && 
            newData[envId]["childNodes"][datasourceId]["childNodes"] && 
            newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId] &&
            newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"] &&
            newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]) {
          newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isOpen"] = true
          newData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"][attributeId]["isShow"] = true
        }
      }
    }

    this.setState({ newData: newData, isDataChanged: !this.state.isDataChanged, isTreeSearch: true, searchTextFound: searchTextFound, subString: filterSearch })
  };
  getId(highlightedType, filteredItem) {
    if (highlightedType === "Environment") {
      return filteredItem["envId"]
    } else if (highlightedType === "Datasource") {
      return filteredItem["datasourceId"]
    } else if (highlightedType === "Dataset") {
      return filteredItem["datasetId"]
    } else {
      return filteredItem["attributeId"]
    }
  }
  changeNavigation(position) {
    let currentIndex = this.state.currentIndex
    let filteredItem;
    let disableUp;
    let disableDown;
    let filteredData = this.props.filteredData
    if (currentIndex - 1 === 0) {
      disableUp = true
    } else {
      disableUp = false
    }
    if (currentIndex === (filteredData.length - 2)) {
      disableDown = true
    } else {
      disableDown = false
    }

    let highlightedType;
    let highlightedId;
    if (position === "down") {
      filteredItem = filteredData[currentIndex + 1]
      currentIndex = currentIndex + 1
      if (filteredItem !== undefined) {
        highlightedType = filteredItem["type"]
        highlightedId = this.getId(highlightedType, filteredItem)
      }
    } else {
      filteredItem = filteredData[currentIndex - 1]
      currentIndex = currentIndex - 1
      if (filteredItem !== undefined) {
        highlightedType = filteredItem["type"]
        highlightedId = this.getId(highlightedType, filteredItem)
      }
    }
    let envName = filteredItem["envName"];
    let datasourceName = filteredItem["datasourceName"]
    let datasetName = filteredItem["datasetName"]
    let attributeName = filteredItem["attributeName"]
    if (highlightedType === "Datasource") {
      datasourceName = filteredItem["name"]
    } else if (highlightedType === "Dataset") {
      datasetName = filteredItem["name"]
    } else if (highlightedType === "Attribute") {
      attributeName = filteredItem["name"]
    } else if (highlightedType === "Environment") {
      envName = filteredItem["name"]
    }
    this.changeData(envName, datasourceName, datasetName, attributeName,
      filteredItem["envId"], filteredItem["datasourceId"],
      filteredItem["datasetId"], filteredItem["attributeId"], highlightedId, highlightedType, currentIndex)
      this.setState({ disableUp: disableUp, disableDown: disableDown })
  }

  reset() {
    this.setState({ envName: "" });
    this.props.clearSearch();
  }

  getIcon(type) {
    if (type === "Environment") {
      return faServer;
    } else if (type === "Datasource") {
      return faDatabase;
    } else if (type === "Dataset") {
      return faLayerGroup;
    } else {
      return faTag;
    }
  }


  getFiltered(data, text, childNodes, original) {
    if (text === original) {
      data["isOpen"] = true
    }
    if (childNodes !== undefined) {
      let data1 = Object.values(childNodes)
      for (let i = 0; i < data1.length; i++) {
        this.getFiltered(data1[i], text, data1[i]["childNodes"], data1[i]["name"])
      }
    }
    else {
      return
    }

  }

  handleTreeViewButton() {
    this.setState({ showTreeView: !this.state.showTreeView })
    setTimeout(function () {
      if ($("#tree-view").hasClass("show")) {
        $('body').addClass("overflow-hidden");
      } else {
        $('body').removeClass("overflow-hidden");
      }
    }, 500);

  }
buildStructureForWatchlist(inputData, id, value, searchText = "", watchlistOpen, envId) {
  if (!inputData) return {};

  const { integrations, datasets, attributes } = inputData;
  let result = {};
  const lowerSearchText = searchText.toLowerCase();
  const isSearchActive = !!searchText;
  const matchesSearch = (text) => text && text.toLowerCase().includes(lowerSearchText);

  if (integrations) {
    integrations
      .filter((integration) => integration.env_id === envId)
      .forEach((integration, index) => {
        const integrationId = integration.value;
        const integrationMatches = matchesSearch(integration.label);

        let integrationNode = {
          title: integration.label,
          type: "Datasource",
          id: integrationId,
          childNodes: [],
          isFirstDatasource: index === 0,
        };

        // Get parent (non-partition) datasets
        const parentDatasets = datasets.filter(
          (dataset) =>
            dataset.integration_id === integrationId &&
            (!dataset.is_child_dataset || dataset.is_child_dataset === undefined)
        );

        let hasMatchingDataset = false;

        parentDatasets.forEach((dataset, datasetIndex) => {
          const datasetId = dataset.value;
          const datasetMatches = matchesSearch(dataset.label);

          let datasetNode = {
            title: dataset.label,
            type: "Dataset",
            id: datasetId,
            integrationId: integrationId,
            childNodes: [],
            firstDataset: !isSearchActive && datasetIndex === 0,
          };

          // ✅ Decide what to include based on match level
          const includeAllChildren = integrationMatches || datasetMatches;

          let hasMatchingAttribute = false;
          let hasMatchingPartition = false;

          // ---------------- ATTRIBUTES ----------------
          const parentAttributes = attributes.filter(attr => attr.data_set_id === datasetId);
          let attributeGroupNode = {
            title: "Select all Attributes",
            type: "Attribute Group",
            id: `attribute-group-${datasetId}`,
            childNodes: [],
          };
          parentAttributes.forEach((attribute) => {
            const attributeMatches = matchesSearch(attribute.label);
            if (includeAllChildren || attributeMatches) {
              let attributeNode = {
                title: normalizeAttributeName(attribute.label),
                type: "Attribute",
                id: attribute.value,
                childNodes: [],
              };
              attributeGroupNode.childNodes.push(attributeNode);
              hasMatchingAttribute = true;
            }
          });

          // Only add Attribute Group if it has any visible attributes
          if (attributeGroupNode.childNodes.length > 0) {
            datasetNode.childNodes.push(attributeGroupNode);
          }

          
          // ---------------- PARTITION GROUP ----------------
          const partitionDatasets = datasets.filter(partition =>
            partition.is_child_dataset &&
            partition.parent_data_set_id === datasetId &&
            partition.integration_id === integrationId
          );

          let partitionNode = {
            title: "Select all Partitions",
            type: "Partition Group",
            id: `partition-group-${datasetId}`,
            childNodes: [],
          };

          partitionDatasets.forEach((partition) => {
            const partitionId = partition.value;
            const partitionMatches = matchesSearch(partition.label);
            const includePartitionChildren = includeAllChildren || datasetMatches || partitionMatches;

            let partitionDatasetNode = {
              title: normalizeChildDatasetName(partition.label),
              type: "Partition",
              id: partitionId,
              childNodes: [],
            };

            // Partition Attributes
            const partitionAttributes = attributes.filter(attr => attr.data_set_id === partitionId);
            let hasPartitionAttributeMatch = false;

            partitionAttributes.forEach((partitionAttribute) => {
              const partitionAttributeMatches = matchesSearch(partitionAttribute.label);
              if (includePartitionChildren || partitionAttributeMatches) {
                let partitionAttributeNode = {
                  title: partitionAttribute.label,
                  type: "Partition Attribute",
                  id: partitionAttribute.value,
                  childNodes: [],
                };
                partitionDatasetNode.childNodes.push(partitionAttributeNode);
                hasPartitionAttributeMatch = true;
              }
            });

            if (includePartitionChildren || partitionMatches || hasPartitionAttributeMatch) {
              partitionNode.childNodes.push(partitionDatasetNode);
              hasMatchingPartition = true;
            }
          });

          // Only add Partition Group if it has any visible partitions
          if (partitionNode.childNodes.length > 0) {
            datasetNode.childNodes.unshift(partitionNode);
          }

          // ✅ Include dataset if itself or any child matched
          if (integrationMatches || datasetMatches || hasMatchingAttribute || hasMatchingPartition) {
            integrationNode.childNodes.push(datasetNode);
            hasMatchingDataset = true;
          }
        });

        // ✅ Include integration if itself or any dataset matched
        if (integrationMatches || hasMatchingDataset) {
          result[integrationId] = integrationNode;
        }
      });
  }

  return result;
}


//function for nested data 
buildNestedStructure(inputData, label, id, searchText, watchlistOpen, envId) {
  if (!inputData) return {};

  let { integrations, datasets, attributes } = inputData;
  let result = {};
  let lowerSearchText = searchText ? searchText.toLowerCase() : "";
  let isSearchActive = !!searchText;

  let matchesSearch = (text) => text && text.toLowerCase().includes(lowerSearchText);

  if (integrations) {
    integrations
      .filter((integration) => integration.env_id === envId)
      .forEach((integration, integrationIndex) => {
        let datasourceId = integration.value;
        let datasourceMatches = matchesSearch(integration.label);
        let datasourceNode = {
          title: integration.label,
          type: "Datasource",
          id: datasourceId,
          envId,
          childNodes: [],
          isOpen: false,
          isFirstDatasource: integrationIndex === 0,
        };

        if (datasets && datasets[datasourceId]) {
          datasets[datasourceId].forEach((dataset, datasetIndex) => {
            let datasetId = dataset.value;

            let datasetNameMatched = matchesSearch(dataset.label);
            let datasetHasMatch = false;
            let hasDatasetMetrics = false;

            let datasetNode = {
              title: normalizeChildDatasetName(dataset.label),
              type: "Dataset",
              id: datasetId,
              error: dataset.error,
              childNodes: [],
              isOpen: false,
              firstDataset: isSearchActive
                ? datasetIndex === 0
                : integrationIndex === 0 && datasetIndex === 0,
            };

            if (!watchlistOpen) {
              let metrics = dataset.metrics || [];
              let customMetrics = dataset.custom_metrics || [];

              // Only filter if dataset name does NOT match
              if (!datasetNameMatched && isSearchActive) {
                metrics = metrics.filter((m) =>
                  matchesSearch(m.metrics_name)
                );
                customMetrics = customMetrics.filter((m) =>
                  matchesSearch(m.metrics_name)
                );
              }

              if (metrics.length > 0) {
                datasetNode.childNodes.push({
                  title: "Metrics",
                  type: "Metrics",
                  id: "metrics_ds_" + datasetId,
                  isOpen: true,
                  childNodes: metrics.map((m) => ({
                    title: m.metrics_name==="Unique Values"?"Unique Rows":m.metrics_name,
                    latest: m.latest,
                    previous: m.previous,
                    error: m.error,
                    id: "dataset_" + m.metrics_id,
                    is_disabled: m.is_disabled,
                  })),
                });
                hasDatasetMetrics = true;
                datasetHasMatch = true;
              }

              if (customMetrics.length > 0) {
                datasetNode.childNodes.push({
                  title: "Custom Metrics",
                  type: "CustomMetrics",
                  id: "cmetrics_ds_" + datasetId,
                  isOpen: true,
                  childNodes: customMetrics.map((m) => ({
                    title: m.metrics_name,
                    latest: m.latest,
                    previous: m.previous,
                    error: m.error,
                    id: "dataset_" + m.metrics_id,
                    is_disabled: m.is_disabled,
                  })),
                });
                hasDatasetMetrics = true;
                datasetHasMatch = true;
              }
            }

            // ============================
            //       ATTRIBUTE LEVEL
            // ============================
            if (attributes && attributes[datasetId]) {
              attributes[datasetId].forEach((attribute) => {
                let attributeId = attribute.value;

                let attributeMatches = matchesSearch(attribute.label);
                let hasAttributeMetrics = false;

               const normalizedTitle = normalizeAttributeName(attribute.label);

              let attributeNode = {
                title: normalizedTitle,
                type: "Attribute",
                id: attributeId,
                error: attribute.error,
                childNodes: [],
                isOpen: false,
              };

                if (!watchlistOpen) {
                  let attrMetrics = attribute.metrics || [];
                  let attrCustomMetrics = attribute.custom_metrics || [];

                  if (!attributeMatches && isSearchActive) {
                    attrMetrics = attrMetrics.filter((m) =>
                      matchesSearch(m.metrics_name)
                    );
                    attrCustomMetrics = attrCustomMetrics.filter((m) =>
                      matchesSearch(m.metrics_name)
                    );
                  }

                  if (attrMetrics.length > 0) {
                    attributeNode.childNodes.push({
                      title: "Metrics",
                      type: "Metrics",
                      id: "metrics_attr_" + attributeId,
                      isOpen: true,
                      childNodes: attrMetrics.map((m) => ({
                        title: m.metrics_name,
                        latest: m.latest,
                        previous: m.previous,
                        error: m.error,
                        id: "attribute_" + m.metrics_id,
                        is_disabled: m.is_disabled,
                      })),
                    });
                    hasAttributeMetrics = true;
                  }

                  if (attrCustomMetrics.length > 0) {
                    attributeNode.childNodes.push({
                      title: "Custom Metrics",
                      type: "CustomMetrics",
                      id: "cmetrics_attr_" + attributeId,
                      isOpen: true,
                      childNodes: attrCustomMetrics.map((m) => ({
                        title: m.metrics_name,
                        latest: m.latest,
                        previous: m.previous,
                        error: m.error,
                        id: "attribute_" + m.metrics_id,
                        is_disabled: m.is_disabled,
                      })),
                    });
                    hasAttributeMetrics = true;
                  }
                }

                // FIX — Do NOT set datasetNameMatched here
                // Attribute match = dataset should appear as parent, not override search flow
                if (attributeMatches || hasAttributeMetrics) {
                  datasetHasMatch = true;
                  datasetNode.isOpen = true;
                  datasourceNode.isOpen = true;
                  attributeNode.isOpen = true;

                  datasetNode.childNodes.push(attributeNode);
                }
              });
            }

            // ============================
            // FINAL DECISION — SHOW DATASET?
            // ============================
            const shouldShowDataset =
              datasetNameMatched || datasetHasMatch || hasDatasetMetrics;

            if (shouldShowDataset) {
              datasetNode.isOpen = true;
              datasourceNode.isOpen = true;

              // If dataset name matched → include all remaining attributes (full expand)
              if (datasetNameMatched && attributes && attributes[datasetId]) {
                attributes[datasetId].forEach((attribute) => {
                  if (!datasetNode.childNodes.some((a) => a.id === attribute.value)) {
                    let attributeNode = {
                      title: attribute.label,
                      type: "Attribute",
                      id: attribute.value,
                      error: attribute.error,
                      isOpen: true,
                      childNodes: [],
                    };

                    let attrMetrics = attribute.metrics || [];
                    let attrCustomMetrics = attribute.custom_metrics || [];

                    if (attrMetrics.length > 0) {
                      attributeNode.childNodes.push({
                        title: "Metrics",
                        type: "Metrics",
                        id: "metrics_attr_" + attribute.value,
                        isOpen: true,
                        childNodes: attrMetrics.map((m) => ({
                          title: m.metrics_name,
                          latest: m.latest,
                          previous: m.previous,
                          error: m.error,
                          id: m.metrics_id,
                          is_disabled: m.is_disabled,
                        })),
                      });
                    }

                    if (attrCustomMetrics.length > 0) {
                      attributeNode.childNodes.push({
                        title: "Custom Metrics",
                        type: "CustomMetrics",
                        id: "cmetrics_attr_" + attribute.value,
                        isOpen: true,
                        childNodes: attrCustomMetrics.map((m) => ({
                          title: m.metrics_name,
                          latest: m.latest,
                          previous: m.previous,
                          error: m.error,
                          id: m.metrics_id,
                          is_disabled: m.is_disabled,
                        })),
                      });
                    }

                    datasetNode.childNodes.push(attributeNode);
                  }
                });
              }

              datasourceNode.childNodes.push(datasetNode);
              datasourceMatches = true;
            }
          });
        }

      if (datasourceMatches) {
        result[datasourceId] = datasourceNode;
      }
    });
  }

  return result;
}




//search in left panel 
handleLeftSearchPanel = (event) => {
  const leftSearchText = event.target.value;
  this.setState({ leftSearchText });

  if (leftSearchText.trim() && this.props.ensureMetaDataResponse) {
    this.props.ensureMetaDataResponse();
  }
};
// Helper to avoid repeating the metric filtering logic
filterMetricsInNode(node, metricsId) {
  if (!node) return node;

  const childNodes = Array.isArray(node.childNodes)
    ? node.childNodes.map((child) => {
        if (!["Metrics", "CustomMetrics"].includes(child.type)) {
          return child;
        }

        const metricNodes = Array.isArray(child.childNodes)
          ? child.childNodes.map((metric) => ({
              ...metric,
              isShow: !metricsId || Number(metric.id) === Number(metricsId)
            }))
          : [];
        const hasMatchingMetric = metricNodes.some((metric) => metric.isShow);

        return {
          ...child,
          childNodes: metricNodes,
          isOpen: hasMatchingMetric,
          isShow: hasMatchingMetric
        };
      })
    : node.childNodes;

  return {
    ...node,
    childNodes,
    isOpen: true,
    isShow: true
  };
}

filterResultByIncidentData(result, incidentData) {
  if (!incidentData) return result;
  const { integration_id, dataset_id, attribute_id, metrics_id } = incidentData;
  // We map over the keys so we keep ALL integrations in the final object
  let updatedResult = {};

  Object.keys(result).forEach((resultKey) => {
    let datasourceNode = { ...result[resultKey] };

    // Only dive deeper if this is the integration we care about
    if (Number(datasourceNode.id) === Number(integration_id)) {
      datasourceNode.childNodes = datasourceNode.childNodes.map((dataset) => {
        // Only dive deeper if this is the dataset we care about
        if (Number(dataset.id) === Number(dataset_id)) {
          let updatedDataset = { ...dataset };

          // Case A: Filter attributes if attribute_id exists
          if (attribute_id && updatedDataset.childNodes?.length > 0) {
            updatedDataset.childNodes = updatedDataset.childNodes.map((attr) => {
              if (attr.type === "Attribute" && Number(attr.id) === Number(attribute_id)) {
                return this.filterMetricsInNode(attr, metrics_id);
              }
              return attr;
            });
          }
          // Case B: Filter metrics directly at dataset level
          else if (metrics_id && updatedDataset.childNodes?.length > 0) {
            updatedDataset = this.filterMetricsInNode(updatedDataset, metrics_id);
          }

          return { ...updatedDataset, firstDataset: true, isShow: true };
        }

        // Partition incidents use the child dataset id. Find that id below the
        // parent dataset's Partition Group and select/filter the child node.
        if (incidentData.is_child && dataset.childNodes?.length > 0) {
          let containsIncidentPartition = false;
          const childNodes = dataset.childNodes.map((group) => {
            if (group.type !== "Partition Group" || !group.childNodes) return group;

            const partitions = group.childNodes.map((partition) => {
              if (Number(partition.id) !== Number(dataset_id)) {
                return { ...partition, firstDataset: false };
              }

              containsIncidentPartition = true;
              return {
                ...this.filterMetricsInNode(partition, metrics_id),
                firstDataset: true,
              };
            });

            return {
              ...group,
              childNodes: partitions,
              isOpen: containsIncidentPartition || group.isOpen,
              isShow: containsIncidentPartition || group.isShow
            };
          });

          return {
            ...dataset,
            childNodes,
            firstDataset: false,
            expanded: containsIncidentPartition || dataset.expanded,
            isOpen: containsIncidentPartition || dataset.isOpen,
            isShow: containsIncidentPartition || dataset.isShow
          };
        }

        return { ...dataset, firstDataset: false };
      });
    }

    updatedResult[resultKey] = datasourceNode;
  });

  return updatedResult;
}



  render() { 
    
    
    let data = []
    if (Object.values(this.state.newData).length > 0) {
      data = Object.values(this.state.newData)
    } else {
      // data = this.state.data !== undefined && this.state.data !== null ? this.props.integrations_data  : [];
    }
    let env_name = this.props.selectedEnv; 
    let env_label = env_name && env_name.label ? env_name.label : this.props.latest_env_name;
    let env_id = env_name && env_name.value ? env_name.value : this.props.latest_env_name;    
    let treedata = null;
    const leftSearchText = this.state.leftSearchText.trim();
    const hasMetadataMapping =
      this.props.metaDataResponse &&
      typeof this.props.metaDataResponse === "object" &&
      !Array.isArray(this.props.metaDataResponse) &&
      Array.isArray(this.props.metaDataResponse.integrations) &&
      Array.isArray(this.props.metaDataResponse.datasets) &&
      Array.isArray(this.props.metaDataResponse.attributes);

    if(this.props.watchListOpen === true){
      data=this.buildStructureForWatchlist(this.props.metaDataResponse,env_label, env_id, this.props.saveWatchListSearchText, this.props.watchListOpen,this.props.selectedEnvId) 
      }
    else if (leftSearchText && hasMetadataMapping) {
      data = Object.values(
        this.buildStructureForWatchlist(
          this.props.metaDataResponse,
          env_label,
          env_id,
          leftSearchText,
          this.props.watchListOpen,
          this.props.selectedEnvId
        )
      );
    }
    else if (this.props.metricsValueResponse && this.props.watchListOpen !== true ) {
      treedata = this.buildNestedStructure(this.props.metricsValueResponse,env_label,env_id,this.state.leftSearchText,this.props.watchListOpen);
       data = this.props.saveWatchListSearchText !== undefined && this.props.saveWatchListSearchText !== "" ? Object.values(this.buildNestedStructure(this.props.metricsValueResponse, env_label, env_id, this.props.saveWatchListSearchText, this.props.watchListOpen,this.props.selectedEnvId)): Object.values(treedata);
    }
    
// Ensure `AllInterationsResponse` integrations are added into the data
if (this.props.AllInterationsResponse && this.props.watchListOpen !== true) {
  // let isFirstDatasource = true;
  let allIntegrations = data; // default to original data

  // When search input is present
  if (this.state.leftSearchText && this.state.leftSearchText.trim().length > 0) {
    let filteredIntegrations = this.props.AllInterationsResponse.filter(integration =>
      integration.label.toLowerCase().includes(this.state.leftSearchText.toLowerCase())
    );

    if (this.props.selectedWatchlistId) {
      filteredIntegrations = filteredIntegrations.filter(integration =>
        integration.value === this.props.selectedWatchlistId
      );
    }

    if (filteredIntegrations.length > 0) {
       allIntegrations = filteredIntegrations.map((integration, index) => {
      const existingIntegration = data.find(item => item.id === integration.value);

      return {
        title: integration.label,
        type: "Datasource",
        id: integration.value,
        envId: this.props.selectedEnvId,
        childNodes: existingIntegration ? existingIntegration.childNodes : [],
        isFirstDatasource: index === 0,
        expanded: index === 0 
        };
      });
    } 
  }

  // ELSE: No search input → only apply watchlist filtering if needed
  else {
    let filteredIntegrations = this.props.AllInterationsResponse;

    if (this.props.selectedWatchlistId) {
      filteredIntegrations = filteredIntegrations.filter(integration =>
        integration.value === this.props.selectedWatchlistId
      );
    }

    if (filteredIntegrations.length > 0) {
      allIntegrations = filteredIntegrations.map((integration, index) => {
      const existingIntegration = data.find(item => item.id === integration.value);

      return {
        title: integration.label,
        type: "Datasource",
        id: integration.value,
        envId: this.props.selectedEnvId,
        childNodes: existingIntegration ? existingIntegration.childNodes : [],
        isFirstDatasource: index === 0,
        expanded: index === 0 
        };
      });
    }
  }

  data = allIntegrations;
}

if (this.props.incidentData?.dataset_id) {
  data = this.filterResultByIncidentData(data, this.props.incidentData);
}

    let profileData = this.state.profileData;
    let keys = ["avg", "min", "max", "std"]
    if (profileData !== undefined && profileData !== null) {
      for (let i = 0; i < keys.length; i++) {
        if (typeof (profileData[keys[i]]["drift"]) === "number") {
          profileData[keys[i]]["drift"] = parseFloat(profileData[keys[i]]["drift"].toFixed(4))
        }
        if (typeof (profileData[keys[i]]["value"]) === "number") {
          profileData[keys[i]]["value"] = parseFloat(profileData[keys[i]]["value"].toFixed(4))
        }
      }
    }

    for (let [key] of Object.entries(activeItem)) {
      activeItem[key] = "breadcrumb-item";
    }
    activeItem[this.state.highlightedType] = 'breadcrumb-item active'
    // let sizeData = 0
    // let filtered = this.props.dataModule.dataSize.filter(x => (this.state.datasetIds.includes(x.data_set_id.toString())))
    // for (let i = 0; i < filtered.length; i++) {
    //   sizeData = sizeData + filtered[i]["size"]

    // }
    // let showTreeView = this.state.showTreeView
    // sizeData = getConvertedSize(sizeData)
    if (data.length > 0) {
      let filteredData = data.filter(item => item.envId !== undefined && item.envId === this.props.selectedEnvId);
      data = filteredData.length > 0 ? filteredData : data;
    }
    return (<><div className="qd_tree-wrapper" id="tree-view">
      <div className="qd_tree-view-container">
        {this.props.isLoadingMetaData === true  && this.props.watchListOpen ? <Load/> : this.state.showSearchFilter ?
          <div className="qd_tree-view-top">
            <div className="title">
              <div className="title-left">
                <label>Main Source</label>
              </div>
              <div className="title-right">
                <ul>
                  <li>New</li>
                  <li>Old</li>
                </ul>
              </div>
            </div>
            <div className="qd-search-bar has-btn-close qd-search-bar--bg-gray">
              <div className="input-group">
                <div className="input-group-prepend">
                  <button id="button-addon4" type="button" className="btn">
                    <svg className='d-block' width="16" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7"/>
                      <path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7"/>
                    </svg>
                  </button>
                </div>
                <input type="search" placeholder="Search..." className="form-control"  onChange={this.handleLeftSearchPanel} value={this.state.leftSearchText}/>
              </div>
              {this.state.leftSearchText && <button className="btn btn-clear" title="clear"onClick={() => this.setState({ leftSearchText: '' })}><i className="icon-close"></i></button>}
            </div>
          </div> 
        : ''}
         {/* <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
        <TreeView data={initialTreeData} defaultExpandedId={6} />
      </div> */}
        { this.props.leftPanelLoader===true ? <Load/> :
        this.state.isRedirect && !(this.state.isTreeSearch) ?
          <div className="search-controls-section">
            <div className="qd_tree-search-controls">
              <p><strong>  {this.props.searchCount}</strong> results</p>
              <div className="search-actions">
                {this.props.filteredData ? <><button disabled={this.state.disableUp || this.props.filteredData.length <= 1} className="btn" id="up" onClick={this.changeNavigation.bind(this, "up")} title="Previous Match (&#8593; Up Arrow)">
                  <i className="icon_arrow-up"></i></button>
                  <span className="icon-divider"></span>
                  <button disabled={this.state.disableDown || this.props.filteredData.length <= 1} className="btn" id="down" onClick={this.changeNavigation.bind(this, "down")} title="Next Match (&#8595; Down Arrow)"><i className="icon_arrow-down"></i></button>
                </>
                  :
                  ""
                }
                <button className="btn" title="Close (Escape)" onClick={this.reset}><i className="icon_cross"></i></button>
              </div>
            </div>
          </div>
          :
          ""
        }
        <Scrollbars className="custom-scrollbar"
          autoHeightMin={0}
          autoHeightMax="calc(100% - 70px)"
          thumbMinSize={30}
          universal={true}
        >
          <div style={{ paddingBottom: '70px' }}>
            <ul className="qd_tree-view vertical-lined-tree-view" key={this.state.isDataChanged}>
              {(data.length === 0 || (typeof data === "object" && Object.keys(data).length === 0)) ?
                  <div className="alert_notree-search-match">
                  <Image
                    src="icon_exclamation_gray"
                  />
                {((Array.isArray(data) && data.length === 0) || data === "") ? (this.props.saveWatchListSearchText || this.state.leftSearchText) ? <p>No matches found for your search</p> : <p>No data found</p>
                   : (typeof data === "object" && Object.keys(data).length === 0) ? <p>No data found</p> : null}
                  </div>
                :
                Object.values(data).map(({ id, title, childNodes, type,isFirstDatasource }, index) => (
                    <Node
                      key={title}
                      isRedirect={this.state.isRedirect || this.state.isTreeSearch}
                      envName={title}
                      isTreeSearch={this.state.isTreeSearch}
                      subString={this.state.leftSearchText }
                     saveWatchListSearchText ={this.props.saveWatchListSearchText}
                      title={title}
                      type={type}
                      isSearchHappened={!this.props.isSearchHappened && !this.state.isTreeSearch}
                      id={id}
                      childNodes={Object.values(childNodes)}
                      // isOpen={false}
                      // isShow={false}
                      highlightedId={this.state.highlightedId}
                      highlightedType={this.state.highlightedType}
                      changeData={this.changeData}
                      showCustomCheckbox={this.state.showCustomCheckbox}
                      isNodeHasActions={this.state.isNodeHasActions}
                      isChecked={this.props.isChecked}
                      handleCheckboxChange={this.state.handleCheckboxChange}
                      arrowIndicator={this.props.arrowIndicator}
                      newValue={this.props.newValue}
                      oldValue={this.props.oldValue}
                      handleSaveWatchlistCheckboxChange ={this.props.handleSaveWatchlistCheckboxChange}
                      checkedStates={this.props.checkedStates}
                      watchListOpen={this.props.watchListOpen}
                      AllInterationsResponse = {this.props.AllInterationsResponse}
                      getMetricsValueResponse = {this.props.getMetricsValueResponse}
                      selectedEnvId = {this.props.selectedEnvId}
                      isFirstDatasource={type === "Datasource" && (
                        this.props.incidentData?.integration_id
                          ? Number(id) === Number(this.props.incidentData.integration_id)
                          : index === 0
                      )}
                      selectedWatchlistId = {this.props.selectedWatchlistId}
                      inProgress = {this.props.inProgress}
                      selectPartitionButton = {this.props.selectPartitionButton}
                      clearCheckedStates = {this.props.clearCheckedStates}
                      isPartitionChecked = {this.props.isPartitionChecked}
                      noDatasetFound = {this.props.noDatasetFound}


                    />
                ))
              }              

            </ul>
          </div>
        </Scrollbars>
      </div>
    </div>
      <div className="qd_tree-overlay"></div>
    </>);

  }
}

export default RealTimeLeftPanel;


class Node extends React.Component {
  constructor(props) {
    super(props);
    let datasourceName = "";
    let datasourceId = null;
    let datasetName = "";
    let datasetId = null;
    let attributeName = "";
    let attributeId = null;
    let envId = null;
    let envName = "";

    if (props.type === "Datasource") {
      datasourceName = props.title;
      datasourceId = props.id;
    } else if (props.type === "Dataset") {
      datasetName = props.title;
      datasetId = props.id;
    } else if (props.type === "Attribute") {
      attributeName = props.title;
      attributeId = props.id;
    } 
    let highlightedClass = ""
    let listClassName = ""
    if (this.props.highlightedId === this.props.id && this.props.highlightedType === this.props.type && this.props.childNodes.length !== 0) {
      highlightedClass = "search-highlight-selected"
      listClassName = "active"
    }else if(this.props.highlightedId === this.props.id && this.props.firstDataset){
      listClassName = "active"
    }

    this.state = {
      isOpen:false,
      isShow: this.props.isShow,
      envName: envName === "" ? this.props.envName : envName,
      datasourceName: datasourceName === "" ? this.props.datasourceName : datasourceName,
      datasetName: datasetName === "" ? this.props.datasetName : datasetName,
      attributeName: attributeName === "" ? this.props.attributeName : attributeName,
      envId: envId === null ? this.props.envId : envId,
      highlightedId: this.props.highlightedId,
      highlightedType: this.props.highlightedType,
      datasourceId: datasourceId === null ? this.props.datasourceId : datasourceId,
      datasetId: datasetId === null ? this.props.datasetId : datasetId,
      attributeId: attributeId === null ? this.props.attributeId : attributeId,
      isChanged: false,
      listClassName: listClassName,
      highlightedClass: highlightedClass,
      showCustomCheckbox : this.props.showCustomCheckbox,
      isNodeHasActions : this.props.isNodeHasActions,
      isChecked:this.props.isChecked,
      checkedStates:this.props.checkedStates,
      isMetricsOpen:false,
      selectedEnvId : this.props.selectedEnvId,
    };
    this.getIcon = this.getIcon.bind(this);
    this.getApi = getApi.bind(this);
    this.toggle = this.toggle.bind(this);
    this.setupClickEvents = this.setupClickEvents.bind(this);
  }


  componentDidUpdate(prevProps) {
    if (prevProps.highlightedId !== this.props.highlightedId || prevProps.highlightedType !== this.props.highlightedType) {
      this.setState({ highlightedType: this.props.highlightedType, highlightedId: this.props.highlightedId });
      if (this.props.highlightedId === this.props.id && this.props.highlightedType === this.props.type) {
        this.setState({ highlightedClass: "search-highlight-selected", listClassName: "active", isActive: true });
      } else {
        this.setState({ highlightedClass: "", listClassName: "", isActive: false });
      }

    }
    if (this.props.watchListOpen && this.props.firstDataset && prevProps.saveWatchListSearchText !== this.props.saveWatchListSearchText) {
        const datasetDivId = `Dataset-left-panel-div-${this.state.datasetId}Dataset`;
        if (!this.state.isOpen) {
          this.toggleForWatchlistOpen(datasetDivId);
        }
      }

    if (!this.props.watchListOpen && this.props.firstDataset && prevProps.subString !== this.props.subString) {
       // const datasetDivId = `Dataset-left-panel-div-${this.state.datasetId}Dataset`;
        // Sync isOpen state from props instead of toggling
        if (this.props.isOpen !== undefined) {
          this.setState({ isOpen: this.props.isOpen });
        }
      }
    if (!prevProps.selectPartitionButton && this.props.selectPartitionButton) {
      const partitionCheckboxFunction = (nodes) => {
        nodes.forEach((node) => {
          if (node.type === 'Partition' || node.type === 'Partition Group') {
            const e = { target: { checked: true } };
            this.props.handleSaveWatchlistCheckboxChange(
              e,
              node.type,
              node.id,
              node.childNodes || []
            );
          }
          if (node.childNodes) partitionCheckboxFunction(node.childNodes);
        });
      };
  
      partitionCheckboxFunction(this.props.childNodes);
    }
    if (prevProps.selectPartitionButton && !this.props.selectPartitionButton) {
      this.props.clearCheckedStates();
    }
  }
      
  toggle = async (clickedId) => {
        // Set the state to toggle 'isOpen'
    this.setState({
        isOpen: !this.state.isOpen,
        listClassName: "active"
    });
      if (this.props.type === "Datasource") {
    this.closeOtherDatasources(clickedId);
  }
    if ((this.props.type === "Metrics" || this.props.type === "CustomMetrics") && this.props.isPartitionChecked) {
      return;
    }

    if(!this.props.subString){
    if(this.props.type === "Dataset"){
      this.setupClickEvents(this.props.type, String(this.props.datasetId), clickedId);
    }
    else if(this.props.type==="Attribute"){
      this.setupClickEvents(this.props.type, String(this.props.attributeId), clickedId);
    }
    else if(this.props.type === "Metrics" || this.props.type === "CustomMetrics"){
      let id= this.state.datasetId
      if(this.state.attributeId!== undefined){
        id= id+this.state.attributeId
      }
      this.setupClickEvents(this.props.type, String(id), clickedId);
    }
  }
    // Set the state to toggle 'isOpen'
    this.setState({
        isOpen: !this.state.isOpen,
        listClassName: "active"
    });


    let isChanged = this.state.isChanged;
    if (!isChanged) {
        this.setState({ isChanged: true });
    }
    const isChild = this.state.datasetName?.includes("$");
    this.props.type === "Datasource" && this.props.watchListOpen !== true && await this.props.getMetricsValueResponse(this.props.selectedWatchlistId ? undefined : this.props.id,this.props.selectedWatchlistId,this.props.isPartitionChecked);
     if(this.props.watchListOpen !== true)
       { 
        if(this.props.type !== undefined)
         {
           this.props.changeData(this.state.envName, this.state.datasourceName,
            this.state.datasetName, this.state.attributeName,
            this.state.envId, this.state.datasourceId,
            this.state.datasetId, this.state.attributeId, this.props.id, this.props.type,this.state.isOpen, null,this.props.title, isChild ?  true  : "")
         }
      else
        {
       this.props.changeData(this.state.envName, this.state.datasourceName,
      this.state.datasetName, this.state.attributeName,
      this.state.envId, this.state.datasourceId,
      this.state.datasetId, this.state.attributeId, this.props.id, this.props.type,false, null,this.props.title, isChild ?  true  : "")
       }
      }
  };
        
  toggleForWatchlistOpen = async () => {
    this.setState({
        isOpen: !this.state.isOpen,
        isActive: false
    });


    let isChanged = this.state.isChanged;
    if (!isChanged) {
        this.setState({ isChanged: true });
    }
  }
  getIcon(type) {     
    if (type === "Environment") {
      return faServer;
    } else if (type === "Datasource") {
      return faDatabase;
    } else if (type === "Dataset") {
      return faLayerGroup;
    } else {
      return faTag;
    }
  }
  getUlClassName(type,childNodes=[]) {
    let className = ""
    if (!Array.isArray(childNodes)) {
      childNodes = [];
    }    
    if (type === "Environment") {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested tree_top-level active" : "nested"
    } else if (type === "Datasource") {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"
    } else if (type === "Dataset" && childNodes.length > 0 && this.props.watchListOpen !== true) {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"
    } else if (type === "Attribute" && childNodes.length > 0 && this.props.watchListOpen !== true){
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"

     }
     else if (type === "Dataset" && childNodes.length > 0 && this.props.watchListOpen === true) {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"
    } else if (type === "Attribute" && childNodes.length > 0 && this.props.watchListOpen === true){
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"

    }
    else if (type === "Partition Group" && childNodes.length > 0 && this.props.watchListOpen === true){
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested active" : "nested has-no-caret"

    }
    else {
      className = this.state.isOpen || (this.props.isSearchHappened && !(this.state.isChanged)) ? "nested has-no-caret active" : "nested has-no-caret"
    }
    return className;
  }
  getHighlightedText(text, highlight) {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));    
    return (parts.map((part, i) =>
      <span key={i} className={part.toLowerCase() === highlight.toLowerCase() ? (this.props.isTreeSearch ? "tree-search-text-highlight" : "search-text-highlight") : ""}>
        {part}
      </span>)
    );
  }

  componentWillUnmount() {
    $(`div[id^='${this.props.type}-left-panel-div-']`).off('click'); // Remove event listeners
  }

  setupClickEvents(type, excludeId = null, clickedId=null) {
    if(type==="Metrics" || type === "CustomMetrics"){
      let existingId = type+"-left-panel-div-"+this.state.datasetId+type
      if(type === "CustomMetrics"){
          existingId = type+"-left-panel-div-"+type
      }
      if (clickedId===existingId && (this.state.attributeId === undefined || this.state.attributeId === null)) {
        this.props.changeData(
          this.state.envName, this.state.datasourceName,
          this.state.datasetName, null,
          this.state.envId, this.state.datasourceId,
          this.state.datasetId, null,
          this.props.id, "Dataset", false, this.props.title
        );

        $(`div[id^='Attribute-left-panel-div-']`).each(function() {
          let id = $(this).attr('id');
             if ($("#" + id).is(" .caret.caret-down")) {
              $("#" + id).trigger("click");
            } else {
            }
        });

      }
       else {
        this.props.changeData(
          this.state.envName, this.state.datasourceName,
          this.state.datasetName, this.state.attributeName,
          this.state.envId, this.state.datasourceId,
          this.state.datasetId, this.state.attributeId,
          this.props.id, "Attribute", false, this.props.title
        );

      }

    }
    else{

      if(this.props.type==="Attribute"){

        $(`div[id^='Metrics-left-panel-div-${this.state.datasetId}Metrics']`).each(function() {
          let id = $(this).attr('id');
          if ($("#" + id).is(" .caret.caret-down")) {
              $("#" + id).trigger("click");
            }
        });
      
        // CustomMetrics-left-panel-div-CustomMetrics
        $(`div[id^='CustomMetrics-left-panel-div-CustomMetrics']`).each(function() {
          let id = $(this).attr('id');
          if ($("#" + id).is(" .caret.caret-down")) {
              $("#" + id).trigger("click");
            }
        });
      
      }
      
      

      $(`div[id^='${type}-left-panel-div-']`).each(function() {
        let id = $(this).attr('id');
        if (id !== type+"-left-panel-div-" + excludeId+type) {
           if ($("#" + id).is(" .caret.caret-down")) {
            $("#" + id).trigger("click");
          } 
        } 
      });
    }

    
  }
closeOtherDatasources(clickedId) {
  const currentId = clickedId;

  $(`div[id^='Datasource-left-panel-div-']`).each(function () {
    const id = $(this).attr("id");

    // Skip clicked datasource
    if (id === currentId) return;

    // If it is currently caret-down, collapse it
    if ($("#" + id).hasClass("caret-down")) {
      $("#" + id).removeClass("caret-down").addClass("caret");
    }
  });
}

 componentDidMount() {  
    if (this.props.firstDataset && !this.props.watchListOpen && !this.props.subString) {
      $(`#${this.state.datasetId}`).addClass("open");
      this.setState({ isActive: true, isOpen: true }, async () => {
        await this.props.changeData(
          this.state.envName, this.state.datasourceName,
          this.state.datasetName, this.state.attributeName,
          this.state.envId, this.state.datasourceId,
          this.state.datasetId, this.state.attributeId,
          this.props.id, this.props.type, false, this.props.title
        );
      });
    }
    else if (this.props.watchListOpen && this.props.firstDataset){
      $(`#${this.state.datasetId}`).addClass("open");
    }
    if (this.props.type === "Datasource" && this.props.isFirstDatasource && !this.state.isOpen && !this.props.watchListOpen && !this.props.subString) {
$(`#Datasource-left-panel-div-${this.props.id}Datasource`).addClass("caret caret-down");
      this.setState({ isOpen: true }, () => this.fetchMetricsValueData());
  }
  }

  fetchMetricsValueData = async () => {
   const { selectedWatchlistId, id } = this.props;
  if (!selectedWatchlistId) {
            await this.props.getMetricsValueResponse(id, undefined,this.props.isPartitionChecked,null,null);
            const isChild = this.state.datasetName?.includes("$");
            !this.props.subString && this.props.watchListOpen !== true && this.props.firstDataset && this.props.changeData(this.state.envName, this.state.datasourceName,
              this.state.datasetName, this.state.attributeName,
              this.state.envId, this.state.datasourceId,
              this.state.datasetId, this.state.attributeId, this.props.id, this.props.type,this.state.isOpen, null,this.props.title, isChild ?  true  : "")
      }  
  else{
            await this.props.getMetricsValueResponse(undefined, selectedWatchlistId,this.props.isPartitionChecked,null,null);
            const isChild = this.state.datasetName?.includes("$");
            !this.props.subString && this.props.watchListOpen !== true && this.props.firstDataset && this.props.isFirstDatasource &&  this.props.changeData(this.state.envName, this.state.datasourceName,
              this.state.datasetName, this.state.attributeName,
              this.state.envId, this.state.datasourceId,
              this.state.datasetId, this.state.attributeId, this.props.id, this.props.type,this.state.isOpen, null,this.props.title, isChild ?  true  : "")
      }
    };
  
   getSelectedCounts = (checkedStates, childNodes) => {
    let counts = { Dataset: 0, Attribute: 0, Partition: 0, PartitionAttribute: 0 };

      const countCheckedNodes = (nodes) => {
        nodes.forEach((node) => {
          if (!node?.type || !node?.id) return;

          const normalizedType = node.type.replace(/\s/g, "");
          const key = `${normalizedType}-${node.id}`;
          const value = checkedStates[key];
               if (value?.checked) {
                  if (normalizedType === "Dataset") {
                    counts.Dataset += 1;
                  } else if (normalizedType === "Attribute") {
                    counts.Attribute += 1;
                  } else if (normalizedType === "Partition") {
                    counts.Partition += 1;
                  } else if (normalizedType === "PartitionAttribute") {
                    counts.PartitionAttribute += 1;
                }
          }

            if (node.childNodes && node.childNodes.length > 0) {
                countCheckedNodes(node.childNodes);
            }
        });
    };

    countCheckedNodes(childNodes);
    return counts;
};

  /**
   * Helper: determines if a node is "effectively checked".
   * A node is effectively checked if:
   *   1. It is explicitly checked in checkedStates, OR
   *   2. All its immediate checkable children are effectively checked (recursive)
   */
  _isNodeEffectivelyChecked = (checkedStates, nodeType, nodeId, nodeChildNodes) => {
    const nt = (nodeType || "").replace(/\s/g, "");
    const key = `${nt}-${nodeId}`;

    // If explicitly checked in state
    if (checkedStates[key]?.checked) return true;

    // Do not auto-derive Dataset checked state from its children.
    if (nt === "Dataset") return false;

    // Normalize childNodes to array (tree data may store them as objects)
    let children = nodeChildNodes;
    if (children && !Array.isArray(children)) {
      children = Object.values(children);
    }

    // If it has children, check if all immediate checkable children are effectively checked
    if (children && children.length > 0) {
      const checkableTypes = ["Attribute", "Partition", "PartitionAttribute", "Dataset",
                              "Datasource", "PartitionGroup", "AttributeGroup"];
      const checkableChildren = children.filter(child => {
        const cnt = (child.type || "").replace(/\s/g, "");
        return checkableTypes.includes(cnt);
      });

      if (checkableChildren.length === 0) return false;

      return checkableChildren.every(child => {
        let grandChildren = child.childNodes || [];
        if (!Array.isArray(grandChildren)) grandChildren = Object.values(grandChildren);
        return this._isNodeEffectivelyChecked(checkedStates, child.type, child.id, grandChildren);
      });
    }

    return false;
  };

  /**
   * Helper: checks if ANY descendant (leaf or group) is checked in checkedStates.
   * Used to detect partial selection for indeterminate state.
   */
  _hasAnyDescendantChecked = (checkedStates, nodes) => {
    // Normalize to array
    let nodeList = nodes;
    if (nodeList && !Array.isArray(nodeList)) {
      nodeList = Object.values(nodeList);
    }
    if (!nodeList || nodeList.length === 0) return false;
    for (const node of nodeList) {
      if (!node?.type || !node?.id) continue;
      const nt = (node.type || "").replace(/\s/g, "");
      const key = `${nt}-${node.id}`;
      if (checkedStates[key]?.checked) return true;
      let childArr = node.childNodes;
      if (childArr && !Array.isArray(childArr)) childArr = Object.values(childArr);
      if (childArr && childArr.length > 0) {
        if (this._hasAnyDescendantChecked(checkedStates, childArr)) return true;
      }
    }
    return false;
  };


/**
   * Determines if a parent node is in an indeterminate state:
   * some (but not all) of its direct children are checked.
   */
  isIndeterminate = (checkedStates, childNodes, type) => {
    if (!childNodes || childNodes.length === 0) return false;

    // Only apply indeterminate logic to group/parent node types
    const groupTypes = ["Datasource", "Dataset", "Partition Group", "Partition", "Attribute Group"];
    if (!groupTypes.includes(type)) return false;

    // If this node itself is explicitly checked in state (e.g. Dataset checked directly),
    // it should NOT show indeterminate — it should show tick.
    // Exception: container/group types (Attribute Group, Partition Group, Datasource, Partition)
    // may have stale explicit state after a child is individually unchecked.
    const selfKey = `${(type || "").replace(/\s/g, "")}-${this.props.id}`;
    const selfNt = (type || "").replace(/\s/g, "");
const containerTypes = ["Datasource", "AttributeGroup", "PartitionGroup", "Partition", "Dataset"];
    if (!containerTypes.includes(selfNt) && checkedStates[selfKey]?.checked) return false;

    // Normalize childNodes to array
    let childArr = childNodes;
    if (childArr && !Array.isArray(childArr)) {
      childArr = Object.values(childArr);
    }

    // Get immediate checkable children
    const checkableTypes = ["Attribute", "Partition", "PartitionAttribute", "Dataset",
                            "Datasource", "PartitionGroup", "AttributeGroup"];
    const checkableChildren = childArr.filter(child => {
      const cnt = (child.type || "").replace(/\s/g, "");
      return checkableTypes.includes(cnt);
    });

    if (checkableChildren.length === 0) return false;

    const effectivelyCheckedCount = checkableChildren.filter(child => {
      let gc = child.childNodes || [];
      if (!Array.isArray(gc)) gc = Object.values(gc);
      return this._isNodeEffectivelyChecked(checkedStates, child.type, child.id, gc);
    }).length;

    if (effectivelyCheckedCount > 0 && effectivelyCheckedCount < checkableChildren.length) {
      return true;
    }

// Also check: if none of the immediate children are fully checked,
    // but some deeper descendant IS checked → still indeterminate
    if (effectivelyCheckedCount === 0 && this._hasAnyDescendantChecked(checkedStates, childArr)) {
      return true;
    }


    return false;
    ;
  };

  /**
   * Determines if all immediate checkable children are effectively checked,
   * meaning the parent should display a tick (checked) icon.
   */
  isAllChildrenChecked = (checkedStates, childNodes, type) => {
    if (!childNodes || childNodes.length === 0) return false;

    // Only apply to group/parent node types
    const groupTypes = ["Datasource", "Dataset", "Partition Group", "Partition", "Attribute Group"];
    if (!groupTypes.includes(type)) return false;

    // Normalize childNodes to array
    let childArr = childNodes;
    if (childArr && !Array.isArray(childArr)) {
      childArr = Object.values(childArr);
    }

    // Get immediate checkable children
    const checkableTypes = ["Attribute", "Partition", "PartitionAttribute", "Dataset",
                            "Datasource", "PartitionGroup", "AttributeGroup"];
    const checkableChildren = childArr.filter(child => {
      const cnt = (child.type || "").replace(/\s/g, "");
      return checkableTypes.includes(cnt);
    });

    if (checkableChildren.length === 0) return false;

    return checkableChildren.every(child => {
      let gc = child.childNodes || [];
      if (!Array.isArray(gc)) gc = Object.values(gc);
      return this._isNodeEffectivelyChecked(checkedStates, child.type, child.id, gc);
    });
  };


 // Add this helper function as a class method
  formatValue(val) {
    if (val === null || val === undefined) return val;
    if (typeof val === 'string') return val;
    const num = Number(val);
    if (Number.isNaN(num)) return val;

    // Compact for thousands: 1500 => 1.5k, 1000 => 1k
    const abs = Math.abs(num);
    if (abs >= 1000) {
      const compact = Math.round((num / 1000) * 10) / 10; // 1 decimal precision
      // If integer after rounding, show no decimal
      const compactStr = (Math.abs(compact % 1) < 1e-9) ? String(Math.trunc(compact)) : compact.toFixed(1);
      return `${compactStr}k`;
    }

    // Otherwise limit to 2 decimal places and remove trailing zeros
    const rounded = Math.round(num * 100) / 100;
    let s = rounded.toFixed(2).replace(/\.?0+$/, '');
    return s;
  }

  render() {
    const { title, childNodes, type,latest,previous } = this.props;
   
    let ulClassName;
    if (childNodes && childNodes.length > 0) {
      ulClassName = this.getUlClassName(type, childNodes);
    } else {
      ulClassName = this.getUlClassName(type);
    }
        let childrenLength = childNodes.filter(x => x.isShow === true)
let normalizedType = (this.props.type || "").replace(/\s+/g, "");
let uniqueId = "";

if (normalizedType === "Datasource") {
  uniqueId = `Datasource-${this.state.datasourceId}`;
} else if (normalizedType === "Dataset") {
  uniqueId = `Dataset-${this.state.datasetId}`;
} else if (normalizedType === "Attribute") {
  uniqueId = `Attribute-${this.state.attributeId}`;
} else if (normalizedType === "Metrics") {
  let id = this.state.datasetId || "";
  if (this.state.attributeId !== undefined) {
    id = `${id}-${this.state.attributeId}`;
  }
  uniqueId = `Metrics-${id}`;
} else if (normalizedType === "PartitionGroup") {
  uniqueId = `PartitionGroup-${this.props.id}`;
} else if (normalizedType === "AttributeGroup") {
  uniqueId = `AttributeGroup-${this.props.id}`;
} else if (normalizedType === "Partition") {
  uniqueId = `Partition-${this.props.id}`;
} else if (normalizedType === "PartitionAttribute") {
  uniqueId = `PartitionAttribute-${this.props.id}`;
}

let selectedCounts = this.getSelectedCounts(this.props.checkedStates, this.props.childNodes);

const getNodeKey = (type, id) => {
  const normalizedType = (type || "").replace(/\s+/g, "");
  // If ID already contains type prefix (string), return as-is
  if (typeof id === "string" && id.startsWith(normalizedType.toLowerCase())) {
    return `${normalizedType}-${id}`; // or just return id if already prefixed fully
  }
  return `${normalizedType}-${id}`;
};
const getDatasetSelectionKey = () => {
  let datasetId = this.props.datasetId;
  if (normalizedType === "AttributeGroup") {
    const match = /^attribute-group-(.+)$/.exec(this.props.id || "");
    if (match) {
      datasetId = match[1];
    }
  } else if (normalizedType === "PartitionGroup") {
    const match = /^partition-group-(.+)$/.exec(this.props.id || "");
    if (match) {
      datasetId = match[1];
    }
  }
  return datasetId ? `Dataset-${datasetId}` : null;
};
const isDatasetSelected = () => {
  const datasetKey = getDatasetSelectionKey();
  return datasetKey ? !!(this.props.checkedStates?.[datasetKey]?.checked) : false;
};
const disallowedToggleTypes = [
  "Attribute",
  "Attribute Group",
  "Partition",
  "Partition Group",
  "Partition Attribute",
];
const isAttributeActionAllowed = !disallowedToggleTypes.includes(type) || isDatasetSelected();
const attributeCheckboxStyle = isAttributeActionAllowed ? {} : { cursor: "not-allowed" };
const disabledCheckboxTooltip = !isAttributeActionAllowed
  ? (["Attribute", "Attribute Group"].includes(type)
      ? "Please select the dataset before selecting the attribute."
      : "Please select the parent dataset before selecting the partition dataset / attributes")
  : null;
const titleContent = (() => {
  const showTooltip =
    (type === "Attribute" && title.length >= 15) ||
    (type === "Dataset" && title.length >=15) ||
    (type === "Datasource" && title.length >= 15);
  const content = this.props.subString ? this.getHighlightedText(title, this.props.subString) : title;
  return showTooltip ? (
    <Tooltip
      placement="top"
      overlay={title}
      trigger={["hover"]}
    >
      <span>{content}</span>
    </Tooltip>
  ) : (
    <span>{content}</span>
  );
})();

// Now render the component
return (
  <li className={`${this.state.isActive ? "active" : this.state.listClassName}`}> 
  {type !== "Attributee" ? 
        <>
        <div 
            className={childNodes.length === 0 &&  !["Datasource", "Attribute"].includes(type)  ? (this.props.watchListOpen !== true ? "d-flex align-items-end w-100":"caret caret-invisible") : (this.state.isOpen || (this.props.isSearchHappened && ["Environment", "Datasource"].includes(type) && !(this.state.isChanged) && childNodes.length !== 0) ? "caret caret-down" : "caret")}
            id={type+"-left-panel-div-"+uniqueId+type}
            // onClick={this.props.watchListOpen !== true ? this.toggle:this.toggleForWatchlistOpen}
            onClick={(event) => {
              const clickedId = event.currentTarget.id;
              if (this.props.watchListOpen !== true && this.props.is_disabled !== true) {
                this.toggle(clickedId); // Pass the id to toggle
              } else {
                this.toggleForWatchlistOpen(clickedId); // Pass the id to toggleForWatchlistOpen
              }
            }}
          >
            
        <div className="qd_tree-label" style={{ pointerEvents: this.props.is_disabled === true ? "none" : "auto", opacity: this.props.is_disabled ? 0.5 : 1 }}        >
            {this.state.showCustomCheckbox ?
              (disabledCheckboxTooltip ? (
                <Tooltip placement="top" overlay={disabledCheckboxTooltip} trigger={["hover"]}>
                  <span style={{ display: "inline-block" }}>
                    <input
                      type="checkbox"
                      id={uniqueId}
                      disabled={!isAttributeActionAllowed}
                      style={attributeCheckboxStyle}
                      onClick={(event) => {
                        if (!isAttributeActionAllowed) {
                          event.preventDefault();
                          event.stopPropagation();
                          return;
                        }
                        event.stopPropagation();
                        this.props.handleSaveWatchlistCheckboxChange(
                          event,
                          this.props.type,
                          this.props.id,
                          this.props.childNodes
                        );
                      }}
                      checked={
                        (() => {
                          const nodeKey = getNodeKey(this.props.type, this.props.id);
                          const nt = (this.props.type || "").replace(/\s+/g, "");
                          const containerTypes = ["Datasource", "AttributeGroup", "PartitionGroup", "Partition"];
                          if (nt === "Dataset") {
                            return this.props.checkedStates[nodeKey]?.checked || false;
                          }
                          if (!containerTypes.includes(nt)) {
                            if (this.props.checkedStates.hasOwnProperty(nodeKey)) {
                              return this.props.checkedStates[nodeKey].checked;
                            }
                          }
                          if (this.isAllChildrenChecked(this.props.checkedStates, this.props.childNodes, this.props.type)) {
                            return true;
                          }
                          return this.props.selectPartitionButton ? ["Partition", "PartitionGroup", "PartitionAttribute"].includes(nt) : false;
                        })()
                      }
                      className={`mr-2${this.isIndeterminate(this.props.checkedStates, this.props.childNodes, this.props.type) ? ' is-indeterminate' : ''}`}
                      ref={(el) => {
                        if (el) {
                          el.indeterminate = this.isIndeterminate(this.props.checkedStates, this.props.childNodes, this.props.type);
                        }
                      }}
                    />
                  </span>
                </Tooltip>
              ) : (
                <input
                  type="checkbox"
                  id={uniqueId}
                  disabled={!isAttributeActionAllowed}
                  style={attributeCheckboxStyle}
                  onClick={(event) => {
                    if (!isAttributeActionAllowed) {
                      event.preventDefault();
                      event.stopPropagation();
                      return;
                    }
                    event.stopPropagation();
                    this.props.handleSaveWatchlistCheckboxChange(
                      event,
                      this.props.type,
                      this.props.id,
                      this.props.childNodes
                    );
                  }}
                  checked={
                    (() => {
                      const nodeKey = getNodeKey(this.props.type, this.props.id);
                      const nt = (this.props.type || "").replace(/\s+/g, "");
                      const containerTypes = ["Datasource", "AttributeGroup", "PartitionGroup", "Partition"];
                      if (nt === "Dataset") {
                        return this.props.checkedStates[nodeKey]?.checked || false;
                      }
                      if (!containerTypes.includes(nt)) {
                        if (this.props.checkedStates.hasOwnProperty(nodeKey)) {
                          return this.props.checkedStates[nodeKey].checked;
                        }
                      }
                      if (this.isAllChildrenChecked(this.props.checkedStates, this.props.childNodes, this.props.type)) {
                        return true;
                      }
                      return this.props.selectPartitionButton ? ["Partition", "PartitionGroup", "PartitionAttribute"].includes(nt) : false;
                    })()
                  }
                  className={`mr-2${this.isIndeterminate(this.props.checkedStates, this.props.childNodes, this.props.type) ? ' is-indeterminate' : ''}`}
                  ref={(el) => {
                    if (el) {
                      el.indeterminate = this.isIndeterminate(this.props.checkedStates, this.props.childNodes, this.props.type);
                    }
                  }}
                />
              ))
            : ''
            }
           {type !== "Partition Group" && type !== "Attribute Group" && <i>
          { type === "Metrics" ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginRight: "4px" }}>
<path d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM5.33333 6.66667C5.14444 6.66667 4.98611 6.73056 4.85833 6.85833C4.73056 6.98611 4.66667 7.14444 4.66667 7.33333V10.6667C4.66667 10.8556 4.73056 11.0139 4.85833 11.1417C4.98611 11.2694 5.14444 11.3333 5.33333 11.3333C5.52222 11.3333 5.68056 11.2694 5.80833 11.1417C5.93611 11.0139 6 10.8556 6 10.6667V7.33333C6 7.14444 5.93611 6.98611 5.80833 6.85833C5.68056 6.73056 5.52222 6.66667 5.33333 6.66667ZM8 4.66667C7.81111 4.66667 7.65278 4.73056 7.525 4.85833C7.39722 4.98611 7.33333 5.14444 7.33333 5.33333V10.6667C7.33333 10.8556 7.39722 11.0139 7.525 11.1417C7.65278 11.2694 7.81111 11.3333 8 11.3333C8.18889 11.3333 8.34722 11.2694 8.475 11.1417C8.60278 11.0139 8.66667 10.8556 8.66667 10.6667V5.33333C8.66667 5.14444 8.60278 4.98611 8.475 4.85833C8.34722 4.73056 8.18889 4.66667 8 4.66667ZM10.6667 8.66667C10.4778 8.66667 10.3194 8.73056 10.1917 8.85833C10.0639 8.98611 10 9.14444 10 9.33333V10.6667C10 10.8556 10.0639 11.0139 10.1917 11.1417C10.3194 11.2694 10.4778 11.3333 10.6667 11.3333C10.8556 11.3333 11.0139 11.2694 11.1417 11.1417C11.2694 11.0139 11.3333 10.8556 11.3333 10.6667V9.33333C11.3333 9.14444 11.2694 8.98611 11.1417 8.85833C11.0139 8.73056 10.8556 8.66667 10.6667 8.66667Z" fill="currentColor"/>
</svg> : (type === "CustomMetrics" ? <Image src="icon_insert_setting_chart"/>
              : type === "Partition" ?  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "4px" }}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 8.44595L2.29089 5.96934C1.90304 5.79333 1.90304 5.20693 2.29089 5.03092L7.75069 2.55431C7.82898 2.51852 7.9141 2.5 8.0002 2.5C8.0863 2.5 8.17126 2.51852 8.24955 2.55431L13.7089 5.03116C14.0967 5.20716 14.0967 5.79333 13.7089 5.96934L12.0398 6.7265C11.7292 6.57773 11.3869 6.5 11.0258 6.5C10.3872 6.5 9.80749 6.7429 9.35844 7.1918C9.06563 7.48466 8.86039 7.8332 8.75313 8.21741L8.24939 8.44595C8.09005 8.51837 7.90971 8.51837 7.75037 8.44595ZM8.67696 9.08519L8.55929 9.13852C8.38204 9.2189 8.19389 9.25968 8.00004 9.25968C7.80619 9.25968 7.6182 9.2189 7.4408 9.13852L3.65271 7.42128L2.29089 8.03838C1.90304 8.21415 1.90304 8.80008 2.29089 8.97586L7.75037 11.4506C7.90971 11.5228 8.09005 11.5228 8.24939 11.4506L9.17956 11.029V10.3225C9.11967 10.2481 9.06384 10.1698 9.01225 10.0878C8.81352 9.77158 8.70837 9.429 8.67696 9.08519ZM9.17956 11.8573L8.55929 12.1385C8.38204 12.2189 8.19389 12.2596 8.00004 12.2596C7.80619 12.2596 7.6182 12.2189 7.4408 12.1385L3.6475 10.4189L2.29089 11.0337C1.90304 11.2094 1.90304 11.7953 2.29089 11.9711L7.75037 14.4459C7.90971 14.518 8.09005 14.518 8.24939 14.4459L8.78015 14.2053C8.70528 13.974 8.66671 13.7289 8.66671 13.4744C8.66671 13.0554 8.7699 12.6354 9.0033 12.2534C9.02917 12.2111 9.05619 12.1697 9.08435 12.1293C9.11479 12.0856 9.14652 12.043 9.17956 12.0016V11.8573Z" fill="#4B5675"/>
                    <path d="M11.0256 14.5C10.7436 14.5 10.5021 14.3996 10.3013 14.1987C10.1004 13.9979 10 13.7564 10 13.4744C10 13.2778 10.047 13.1026 10.141 12.9487C10.235 12.7949 10.359 12.6709 10.5128 12.5769V9.74359C10.359 9.64957 10.235 9.52778 10.141 9.37821C10.047 9.22863 10 9.05556 10 8.85897C10 8.57692 10.1004 8.33547 10.3013 8.13462C10.5021 7.93376 10.7436 7.83333 11.0256 7.83333C11.3077 7.83333 11.5491 7.93376 11.75 8.13462C11.9509 8.33547 12.0513 8.57692 12.0513 8.85897C12.0513 9.05556 12.0043 9.22863 11.9103 9.37821C11.8162 9.52778 11.6923 9.64957 11.5385 9.74359V11.2179L13.5897 10.5385V9.74359C13.4359 9.64957 13.312 9.52778 13.2179 9.37821C13.1239 9.22863 13.0769 9.05556 13.0769 8.85897C13.0769 8.57692 13.1773 8.33547 13.3782 8.13462C13.5791 7.93376 13.8205 7.83333 14.1026 7.83333C14.3846 7.83333 14.6261 7.93376 14.8269 8.13462C15.0278 8.33547 15.1282 8.57692 15.1282 8.85897C15.1282 9.05556 15.0812 9.22863 14.9872 9.37821C14.8932 9.52778 14.7692 9.64957 14.6154 9.74359V10.5256C14.6154 10.7479 14.5513 10.9487 14.4231 11.1282C14.2949 11.3077 14.1239 11.4316 13.9103 11.5L11.5385 12.2949V12.5769C11.6923 12.6709 11.8162 12.7949 11.9103 12.9487C12.0043 13.1026 12.0513 13.2778 12.0513 13.4744C12.0513 13.7564 11.9509 13.9979 11.75 14.1987C11.5491 14.3996 11.3077 14.5 11.0256 14.5Z" fill="#4B5675"/>
                    </svg> :  type ? (
                <FontAwesomeIcon icon={this.getIcon(type)} />
              ) :(
                <span>{getIconforMetrics(title)}</span>
              ))}
              {this.props.error && <sup>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.26392C5.14167 7.26392 5.26042 7.21751 5.35625 7.1247C5.45208 7.03188 5.5 6.91687 5.5 6.77966C5.5 6.64245 5.45208 6.52744 5.35625 6.43462C5.26042 6.34181 5.14167 6.2954 5 6.2954C4.85833 6.2954 4.73958 6.34181 4.64375 6.43462C4.54792 6.52744 4.5 6.64245 4.5 6.77966C4.5 6.91687 4.54792 7.03188 4.64375 7.1247C4.73958 7.21751 4.85833 7.26392 5 7.26392ZM5 5.32688C5.14167 5.32688 5.26042 5.28047 5.35625 5.18765C5.45208 5.09483 5.5 4.97982 5.5 4.84262V2.90557C5.5 2.76836 5.45208 2.65335 5.35625 2.56053C5.26042 2.46772 5.14167 2.42131 5 2.42131C4.85833 2.42131 4.73958 2.46772 4.64375 2.56053C4.54792 2.65335 4.5 2.76836 4.5 2.90557V4.84262C4.5 4.97982 4.54792 5.09483 4.64375 5.18765C4.73958 5.28047 4.85833 5.32688 5 5.32688ZM5 9.68523C4.30833 9.68523 3.65833 9.55811 3.05 9.30387C2.44167 9.04964 1.9125 8.7046 1.4625 8.26877C1.0125 7.83293 0.65625 7.32042 0.39375 6.73124C0.13125 6.14205 0 5.51251 0 4.84262C0 4.17272 0.13125 3.54318 0.39375 2.95399C0.65625 2.36481 1.0125 1.8523 1.4625 1.41646C1.9125 0.98063 2.44167 0.635593 3.05 0.381356C3.65833 0.127119 4.30833 0 5 0C5.69167 0 6.34167 0.127119 6.95 0.381356C7.55833 0.635593 8.0875 0.98063 8.5375 1.41646C8.9875 1.8523 9.34375 2.36481 9.60625 2.95399C9.86875 3.54318 10 4.17272 10 4.84262C10 5.51251 9.86875 6.14205 9.60625 6.73124C9.34375 7.32042 8.9875 7.83293 8.5375 8.26877C8.0875 8.7046 7.55833 9.04964 6.95 9.30387C6.34167 9.55811 5.69167 9.68523 5 9.68523Z" fill="#F64E60"/>
                </svg>
              </sup>}
            </i>}
            {this.props.noDatasetFound ? (
                <Tooltip
                  placement="top"
                overlay="No dataset found"
                  trigger={["hover"]}
                >
              <span style={{pointerEvents: "auto"}} onClick={(e) => e.stopPropagation()}>{titleContent}</span>
             </Tooltip>) : (titleContent)}
            {/* <OverlayTrigger trigger="click" rootClose placement="right" overlay={
              <Popover className="ai-popover">
                <Popover.Content>
                    <i className='icon-close'>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </i>
                    <div class="ai-popover__stack">
                      <div className="ai-popover__result">
                        <p className="ai-popover__result-label">Total Customers</p>
                        <span className="ai-popover__result-value">84%</span>
                      </div>
                      <div className="ai-popover__summary">
                        <h6>AI Explained</h6>
                        <p>Lorem ipsum dolor sit amet, di os consectetur adipiscing elit, sed do eiusmod tempor incididunt ut fsil labore et dolore magna aliqua.</p>
                      </div>
                      <div class="line-divider"></div>
                      <div class="ai-popover__meta">
                        <h6>Main source</h6>
                        <ul>
                          <li>
                            <FontAwesomeIcon icon={faLayerGroup} />DWD_CUST_LTV_SVM_FACTOR
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="ai-popover__action">
                        <div class="ai-popover__action-left">
                          <button>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.0071 1.04302C10.4942 1.04905 10.9737 1.16503 11.4097 1.38237C11.8457 1.59974 12.227 1.91291 12.525 2.29831C12.823 2.68368 13.0298 3.13151 13.1305 3.60812C13.2309 4.08395 13.2226 4.57634 13.1064 5.04855L12.4611 7.70968H16.5244C16.8802 7.70969 17.2312 7.79269 17.5494 7.95179C17.8675 8.11088 18.1441 8.34189 18.3575 8.62643C18.571 8.91105 18.7154 9.24157 18.7791 9.5916C18.8427 9.94156 18.8241 10.3016 18.7245 10.643L16.7828 17.3093C16.644 17.7853 16.3543 18.204 15.9576 18.5015C15.5609 18.799 15.0785 18.9597 14.5827 18.9597H3.33268C2.72489 18.9597 2.14217 18.7181 1.7124 18.2883C1.28263 17.8585 1.04102 17.2758 1.04102 16.668V10.0013C1.04102 9.39356 1.28263 8.81084 1.7124 8.38107C2.14217 7.9513 2.72489 7.70968 3.33268 7.70968H5.63249L5.70492 7.70724C5.87323 7.6954 6.03655 7.6427 6.18058 7.55343C6.34528 7.4513 6.47846 7.30502 6.5647 7.13148L9.44067 1.38807L9.46183 1.34901C9.5752 1.1579 9.78266 1.04024 10.0071 1.04302ZM7.68327 7.68934C7.49352 8.07047 7.2012 8.39106 6.83936 8.61544C6.71794 8.69073 6.58979 8.75276 6.45768 8.80384V17.7097H14.5827C14.8081 17.7097 15.0274 17.6366 15.2077 17.5013C15.388 17.3661 15.5193 17.1761 15.5824 16.9598L17.5242 10.2931L17.5396 10.2345C17.5712 10.097 17.5747 9.95422 17.5494 9.81499C17.5205 9.6559 17.4548 9.50571 17.3577 9.37635C17.2607 9.24699 17.1349 9.14187 16.9903 9.06955C16.8457 8.99724 16.6861 8.95969 16.5244 8.95968H11.666C11.4743 8.95968 11.2934 8.87153 11.1749 8.72083C11.0564 8.57018 11.0134 8.37363 11.0585 8.18738L11.8918 4.75395L11.8927 4.75151C11.9643 4.46142 11.9694 4.15886 11.9077 3.8665C11.846 3.57411 11.719 3.29929 11.5362 3.06287C11.3534 2.82646 11.1192 2.63469 10.8518 2.50135C10.697 2.42417 10.5332 2.36819 10.3647 2.33371L7.68327 7.68934ZM2.29102 16.668C2.29102 16.9443 2.40084 17.2092 2.59619 17.4045C2.79154 17.5999 3.05642 17.7097 3.33268 17.7097H5.20768V8.95968H3.33268C3.05642 8.95968 2.79154 9.06951 2.59619 9.26486C2.40084 9.46021 2.29102 9.72508 2.29102 10.0013V16.668Z" fill="#484848"/>
                            </svg>
                          </button>
                          <button>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17.7086 3.33464C17.7086 3.05838 17.5988 2.79349 17.4035 2.59814C17.2081 2.40281 16.9432 2.29299 16.667 2.29297H14.792V11.043H16.667C16.9432 11.043 17.2081 10.9331 17.4035 10.7378C17.5988 10.5424 17.7086 10.2776 17.7086 10.0013V3.33464ZM5.41697 2.29297C5.1916 2.29297 4.97227 2.36609 4.79197 2.5013C4.63418 2.61964 4.51358 2.77994 4.44366 2.96313L4.4168 3.04289L2.47548 9.70955C2.4302 9.8648 2.42132 10.0286 2.45025 10.1877C2.47918 10.3468 2.54487 10.4969 2.6419 10.6263C2.73893 10.7557 2.86469 10.8608 3.00933 10.9331C3.15397 11.0054 3.31352 11.043 3.47523 11.043H8.33363C8.52531 11.043 8.70628 11.1311 8.82476 11.2818C8.94319 11.4325 8.98628 11.629 8.94113 11.8153L8.1078 15.2487L8.10699 15.2511C8.03537 15.5412 8.03022 15.8438 8.09193 16.1361C8.15366 16.4285 8.28064 16.7034 8.46343 16.9398C8.64618 17.1761 8.88008 17.368 9.14743 17.5013C9.30204 17.5784 9.4659 17.634 9.63409 17.6685L12.3164 12.3133C12.5061 11.9323 12.7981 11.6116 13.1599 11.3872C13.2814 11.3119 13.4098 11.2495 13.542 11.1984V2.29297H5.41697ZM18.9586 10.0013C18.9586 10.6091 18.717 11.1918 18.2872 11.6216C17.8575 12.0513 17.2747 12.293 16.667 12.293H14.3672L14.2947 12.2954C14.1263 12.3072 13.9628 12.3599 13.8187 12.4492C13.654 12.5513 13.5212 12.6976 13.4349 12.8712L10.559 18.6146C10.4518 18.8285 10.2319 18.9626 9.99257 18.9596C9.50548 18.9536 9.02594 18.8376 8.58998 18.6203C8.15401 18.4029 7.77266 18.0897 7.47466 17.7043C7.17668 17.319 6.96943 16.8712 6.86879 16.3945C6.76831 15.9186 6.77654 15.426 6.8928 14.9537L7.53855 12.293H3.47523C3.11946 12.293 2.76846 12.21 2.45025 12.0509C2.13211 11.8918 1.85516 11.6608 1.64174 11.3762C1.42833 11.0916 1.28423 10.761 1.22059 10.4111C1.15699 10.0611 1.17552 9.7011 1.27512 9.35962L3.21685 2.69336C3.35569 2.21735 3.64537 1.79865 4.04205 1.50114C4.43869 1.20371 4.92119 1.04297 5.41697 1.04297H16.667C17.2747 1.04299 17.8575 1.2846 18.2872 1.71436C18.717 2.14412 18.9586 2.72686 18.9586 3.33464V10.0013Z" fill="#484848"/>
                            </svg>
                          </button>
                        </div>
                        <div class="ai-popover__action-right">
                          <button className="btn btn-light-blue">View Details</button>
                        </div>
                      </div>
                </Popover.Content>
              </Popover>
            }>
              <sup className='tree-ai-indicator'>
                <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_21481_132518)">
                  <path d="M4.00065 0.800781C1.97665 0.800781 0.333984 2.44345 0.333984 4.46745C0.333984 6.49145 1.97665 8.13411 4.00065 8.13411C6.02465 8.13411 7.66732 6.49145 7.66732 4.46745C7.66732 2.44345 6.02465 0.800781 4.00065 0.800781ZM7.32998 4.12278L6.55632 3.49211L6.95965 2.90545C7.15765 3.27578 7.28232 3.68645 7.32998 4.12278ZM3.09498 3.97611C3.06198 4.07878 3.02165 4.18145 2.97398 4.28778C2.80532 4.67645 2.59265 5.00278 2.36898 5.27045C2.35065 5.18245 2.33598 5.09445 2.32132 5.00278C2.21865 4.30245 2.26998 3.66811 2.38732 3.12911C2.51198 3.16945 2.64398 3.21345 2.77965 3.26845L3.09498 3.97978V3.97611ZM2.98498 3.34911C3.06565 3.38211 3.14998 3.42245 3.23432 3.46278C3.21598 3.56178 3.19032 3.66078 3.16098 3.76345L2.98498 3.34911ZM3.15732 4.36478C3.17565 4.32445 3.19765 4.28411 3.21232 4.24011L3.82832 5.63345C3.50565 6.05145 3.18298 6.40345 2.87865 6.70411C2.69532 6.35578 2.52298 5.94145 2.41298 5.46478C2.68065 5.17145 2.94465 4.80845 3.15732 4.36478ZM3.28932 4.05678C3.35532 3.89178 3.40298 3.73045 3.44332 3.56911C3.60832 3.65345 3.77332 3.75245 3.94198 3.85878C3.96765 4.07145 4.01898 4.29511 4.09598 4.52245C4.15098 4.68745 4.21698 4.84145 4.29032 4.98445C4.16565 5.17145 4.04465 5.34745 3.91632 5.51611L3.28932 4.05678ZM4.56165 3.82211C4.41865 3.72311 4.27565 3.63511 4.13265 3.55445C4.10698 2.96411 4.23532 2.43978 4.38565 2.03645L5.34632 2.87611C5.21432 3.23545 5.04932 3.62411 4.84398 4.02378C4.75232 3.95778 4.66065 3.88811 4.56165 3.82211ZM4.64965 4.39045C4.59098 4.50045 4.52498 4.61045 4.45898 4.72045C4.44432 4.74245 4.42965 4.76811 4.41498 4.79011C4.38198 4.70945 4.34898 4.62878 4.32332 4.54445C4.26465 4.36845 4.22065 4.19611 4.19132 4.03111C4.21332 4.04578 4.23532 4.06045 4.25732 4.07878C4.39665 4.18145 4.52865 4.28778 4.65332 4.39411L4.64965 4.39045ZM4.49932 5.35478C4.58365 5.48678 4.67532 5.61145 4.77432 5.72145L4.31232 6.43645L4.07765 5.89011C4.21698 5.72145 4.35998 5.54178 4.49932 5.35111V5.35478ZM4.61298 5.19711C4.70098 5.07245 4.78898 4.94045 4.87698 4.80845C4.90632 4.76445 4.93198 4.72045 4.95765 4.67645C5.06398 4.77911 5.16298 4.88178 5.25465 4.98445L4.86965 5.57845C4.77798 5.46111 4.69365 5.33278 4.61298 5.19711ZM5.18132 4.29878C5.39765 3.92111 5.57732 3.55445 5.72398 3.20978L6.15665 3.59111L5.50765 4.59578C5.40865 4.49678 5.29865 4.39778 5.18498 4.29878H5.18132ZM6.36565 3.77445L7.14665 4.46011C6.87165 4.62511 6.49032 4.90011 6.16765 5.34011C6.02832 5.15678 5.86698 4.96245 5.67998 4.76811L6.36565 3.77078V3.77445ZM6.14565 2.04011C6.16032 1.99978 6.16765 1.96311 6.17865 1.92645C6.37665 2.09145 6.55265 2.28211 6.70298 2.49111C6.73232 2.53145 6.76165 2.57178 6.78732 2.60845L6.33632 3.30511L5.84865 2.90545C5.96965 2.59378 6.06865 2.30045 6.14565 2.03645V2.04011ZM5.36465 1.41311C5.48932 1.46811 5.60665 1.53045 5.72398 1.60011C5.71665 1.62945 5.70932 1.65878 5.70565 1.68445C5.64332 1.95211 5.56265 2.25278 5.44898 2.58278L4.48465 1.79811C4.61665 1.50478 4.74865 1.29945 4.80365 1.21511C4.99798 1.26278 5.18498 1.32511 5.36465 1.40945V1.41311ZM4.00065 1.11978C4.19498 1.11978 4.38932 1.13811 4.57265 1.17111C4.51765 1.25545 4.41498 1.42045 4.30498 1.65145L3.67065 1.13445C3.78065 1.12345 3.88698 1.11978 4.00065 1.11978ZM3.41032 1.17478L4.20965 1.87878C4.04465 2.27845 3.89798 2.81378 3.90898 3.42978C3.77698 3.36011 3.64498 3.29778 3.51665 3.23911C3.68532 2.27845 3.48732 1.45711 3.41032 1.17845V1.17478ZM3.11698 1.36545C3.20132 1.63311 3.38465 2.30411 3.28565 3.13645C3.12798 3.07045 2.97032 3.01545 2.81998 2.96411L2.58898 2.42511C2.76865 1.92278 3.00698 1.53778 3.11698 1.36178V1.36545ZM2.51198 2.65611L2.62198 2.90545C2.56332 2.88711 2.50832 2.87245 2.45332 2.85778C2.47165 2.78811 2.49365 2.72211 2.51198 2.65611ZM2.39098 1.53411C2.36532 1.58911 2.33232 1.66245 2.29565 1.75045L2.24065 1.62578C2.28832 1.59278 2.33965 1.56345 2.39098 1.53778V1.53411ZM2.09398 1.71745L2.20398 1.97045C2.12698 2.17945 2.04265 2.44345 1.97298 2.74778C1.82632 2.71845 1.68698 2.69645 1.56232 2.67811C1.56232 2.48745 1.54765 2.32611 1.52932 2.20878C1.69798 2.02545 1.88498 1.86045 2.09032 1.71745H2.09398ZM1.43032 3.52145C1.49998 3.30511 1.53665 3.10345 1.55498 2.91645C1.66865 2.93845 1.79332 2.96411 1.92898 2.99711C1.80432 3.66811 1.77132 4.50411 2.00598 5.42078C2.02065 5.48311 2.03898 5.54545 2.05732 5.60778C1.89232 5.76545 1.73465 5.89745 1.58798 6.00011L0.876651 4.50411C1.07465 4.27311 1.29465 3.94678 1.43398 3.51778L1.43032 3.52145ZM1.35332 2.42145C1.36065 2.49111 1.36798 2.56811 1.36798 2.65611C1.30932 2.64878 1.25065 2.64511 1.19932 2.64145C1.24698 2.56445 1.29832 2.49111 1.35698 2.42145H1.35332ZM1.07098 2.84678C1.15532 2.85411 1.25065 2.86878 1.36065 2.88345C1.34965 3.07778 1.31298 3.29778 1.24332 3.53245C1.13332 3.88811 0.971984 4.17411 0.817984 4.39045L0.674984 4.08978C0.722651 3.64245 0.861984 3.22078 1.07098 2.84678ZM0.656651 4.54078L0.674984 4.57378C0.674984 4.57378 0.663984 4.58478 0.660318 4.59211C0.660318 4.57378 0.660318 4.55911 0.660318 4.54078H0.656651ZM0.663984 4.72045C0.682318 4.70578 0.700651 4.68745 0.718984 4.66545L1.44865 6.09178C1.34598 6.16145 1.25432 6.21645 1.17732 6.26045C0.887651 5.80945 0.707984 5.28511 0.663984 4.72411V4.72045ZM1.25065 6.37411C1.32765 6.33378 1.41565 6.27878 1.51465 6.21645L1.98398 7.13678C1.70165 6.92412 1.45598 6.66378 1.25432 6.37411H1.25065ZM2.19298 7.28345L1.64298 6.12845C1.78598 6.02945 1.93998 5.91211 2.10132 5.76911C2.24432 6.21645 2.43498 6.60511 2.63298 6.93878C2.48632 7.07445 2.34698 7.19178 2.21865 7.30178C2.21132 7.30178 2.20398 7.29445 2.19298 7.28712V7.28345ZM2.47898 7.44845C2.57798 7.36778 2.68432 7.28345 2.79432 7.18811C2.92998 7.38978 3.06565 7.56578 3.19398 7.71245C2.94465 7.65012 2.70632 7.56212 2.48265 7.44478L2.47898 7.44845ZM3.03632 6.97545C3.33698 6.70045 3.66332 6.37778 3.98965 5.99645L4.23898 6.55378L3.52398 7.65745C3.37732 7.48145 3.20498 7.25411 3.03632 6.97545ZM4.00065 7.81511C3.87965 7.81511 3.75865 7.80778 3.63765 7.79678C3.62665 7.79678 3.61565 7.79678 3.60465 7.79311L3.61565 7.77478L4.31965 6.75178L4.75232 7.73078C4.51032 7.78578 4.25732 7.81511 3.99698 7.81511H4.00065ZM5.51498 7.45211C5.30598 7.55845 5.08598 7.64278 4.85865 7.70145L4.40032 6.63811L4.92098 5.88278C5.15932 6.13211 5.40865 6.32645 5.62865 6.47311C5.52598 6.86178 5.51132 7.21011 5.51865 7.45211H5.51498ZM5.00898 5.75078L5.40865 5.16411C5.59198 5.38411 5.74599 5.60045 5.87799 5.80578C5.78265 5.99278 5.70932 6.17611 5.65798 6.35211C5.44532 6.19445 5.21798 5.99645 5.00898 5.75445V5.75078ZM5.73865 7.32745C5.74965 7.15145 5.77898 6.90211 5.85965 6.61612C6.10165 6.75545 6.28498 6.82511 6.34732 6.85078C6.16398 7.03045 5.95865 7.19178 5.73498 7.32378L5.73865 7.32745ZM6.40232 6.79578C6.40232 6.79578 6.39865 6.78478 6.39498 6.77745C6.27032 6.72245 6.09432 6.63445 5.89265 6.50978C5.93665 6.37778 5.99165 6.24211 6.06132 6.10278C6.21165 6.36678 6.32165 6.59778 6.39498 6.77745C6.40232 6.77745 6.40598 6.78111 6.40965 6.78478C6.40965 6.78845 6.40598 6.79211 6.40232 6.79578ZM6.36565 5.61511C6.70298 5.17511 7.08798 4.92211 7.32998 4.79011C7.27865 5.34745 7.08798 5.86811 6.79098 6.31545C6.68832 6.12478 6.54899 5.88278 6.36565 5.61511Z" fill="#3160D5"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_21481_132518">
                  <rect width="8" height="8" fill="white" transform="translate(0 0.46875)"/>
                  </clipPath>
                  </defs>
                </svg>
              </sup>
            </OverlayTrigger> */}
            {this.props.watchListOpen && (
              <>
                {/* Show Dataset count under the Datasource */}
                {this.props.type === "Datasource" && selectedCounts.Dataset > 0 && (
                  <span style={{ marginLeft: "10px" }}>[<span className="text-blue"> <FontAwesomeIcon icon={this.getIcon("Dataset")} style={{ marginRight: "4px" }}/> {selectedCounts.Dataset}</span>]</span>
                )}

                {/* Show Attribute count under the Dataset */}
                {this.props.type === "Dataset" && (selectedCounts.Attribute > 0 || selectedCounts.Partition > 0 )&& (
                  <div className="mx-1"style={{ marginLeft: "10px" }}> <div className="tree-nodes-enabled-count mr-1">{"["}{selectedCounts.Attribute > 0 && (<> <span className="text-blue"><FontAwesomeIcon icon={this.getIcon("Attribute")} style={{ marginRight: "4px" }}/>{selectedCounts.Attribute}</span> {"]"}</>)}
                    {selectedCounts.Partition > 0 && (<>
                         {"["}<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "4px" }}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 8.44595L2.29089 5.96934C1.90304 5.79333 1.90304 5.20693 2.29089 5.03092L7.75069 2.55431C7.82898 2.51852 7.9141 2.5 8.0002 2.5C8.0863 2.5 8.17126 2.51852 8.24955 2.55431L13.7089 5.03116C14.0967 5.20716 14.0967 5.79333 13.7089 5.96934L12.0398 6.7265C11.7292 6.57773 11.3869 6.5 11.0258 6.5C10.3872 6.5 9.80749 6.7429 9.35844 7.1918C9.06563 7.48466 8.86039 7.8332 8.75313 8.21741L8.24939 8.44595C8.09005 8.51837 7.90971 8.51837 7.75037 8.44595ZM8.67696 9.08519L8.55929 9.13852C8.38204 9.2189 8.19389 9.25968 8.00004 9.25968C7.80619 9.25968 7.6182 9.2189 7.4408 9.13852L3.65271 7.42128L2.29089 8.03838C1.90304 8.21415 1.90304 8.80008 2.29089 8.97586L7.75037 11.4506C7.90971 11.5228 8.09005 11.5228 8.24939 11.4506L9.17956 11.029V10.3225C9.11967 10.2481 9.06384 10.1698 9.01225 10.0878C8.81352 9.77158 8.70837 9.429 8.67696 9.08519ZM9.17956 11.8573L8.55929 12.1385C8.38204 12.2189 8.19389 12.2596 8.00004 12.2596C7.80619 12.2596 7.6182 12.2189 7.4408 12.1385L3.6475 10.4189L2.29089 11.0337C1.90304 11.2094 1.90304 11.7953 2.29089 11.9711L7.75037 14.4459C7.90971 14.518 8.09005 14.518 8.24939 14.4459L8.78015 14.2053C8.70528 13.974 8.66671 13.7289 8.66671 13.4744C8.66671 13.0554 8.7699 12.6354 9.0033 12.2534C9.02917 12.2111 9.05619 12.1697 9.08435 12.1293C9.11479 12.0856 9.14652 12.043 9.17956 12.0016V11.8573Z" fill="#4B5675"/>
                    <path d="M11.0256 14.5C10.7436 14.5 10.5021 14.3996 10.3013 14.1987C10.1004 13.9979 10 13.7564 10 13.4744C10 13.2778 10.047 13.1026 10.141 12.9487C10.235 12.7949 10.359 12.6709 10.5128 12.5769V9.74359C10.359 9.64957 10.235 9.52778 10.141 9.37821C10.047 9.22863 10 9.05556 10 8.85897C10 8.57692 10.1004 8.33547 10.3013 8.13462C10.5021 7.93376 10.7436 7.83333 11.0256 7.83333C11.3077 7.83333 11.5491 7.93376 11.75 8.13462C11.9509 8.33547 12.0513 8.57692 12.0513 8.85897C12.0513 9.05556 12.0043 9.22863 11.9103 9.37821C11.8162 9.52778 11.6923 9.64957 11.5385 9.74359V11.2179L13.5897 10.5385V9.74359C13.4359 9.64957 13.312 9.52778 13.2179 9.37821C13.1239 9.22863 13.0769 9.05556 13.0769 8.85897C13.0769 8.57692 13.1773 8.33547 13.3782 8.13462C13.5791 7.93376 13.8205 7.83333 14.1026 7.83333C14.3846 7.83333 14.6261 7.93376 14.8269 8.13462C15.0278 8.33547 15.1282 8.57692 15.1282 8.85897C15.1282 9.05556 15.0812 9.22863 14.9872 9.37821C14.8932 9.52778 14.7692 9.64957 14.6154 9.74359V10.5256C14.6154 10.7479 14.5513 10.9487 14.4231 11.1282C14.2949 11.3077 14.1239 11.4316 13.9103 11.5L11.5385 12.2949V12.5769C11.6923 12.6709 11.8162 12.7949 11.9103 12.9487C12.0043 13.1026 12.0513 13.2778 12.0513 13.4744C12.0513 13.7564 11.9509 13.9979 11.75 14.1987C11.5491 14.3996 11.3077 14.5 11.0256 14.5Z" fill="#4B5675"/>
                    </svg><span className="text-blue">{" "}{selectedCounts.Partition} </span> {"]"}</>)}</div></div>
                )}
                {this.props.type === "Partition Group" && selectedCounts.Partition > 0 && (
                  <div className="mx-1" style={{ marginLeft: "10px" }}><div className="tree-nodes-enabled-count mr-1">{"["} <span className="text-blue">
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "4px" }}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 8.44595L2.29089 5.96934C1.90304 5.79333 1.90304 5.20693 2.29089 5.03092L7.75069 2.55431C7.82898 2.51852 7.9141 2.5 8.0002 2.5C8.0863 2.5 8.17126 2.51852 8.24955 2.55431L13.7089 5.03116C14.0967 5.20716 14.0967 5.79333 13.7089 5.96934L12.0398 6.7265C11.7292 6.57773 11.3869 6.5 11.0258 6.5C10.3872 6.5 9.80749 6.7429 9.35844 7.1918C9.06563 7.48466 8.86039 7.8332 8.75313 8.21741L8.24939 8.44595C8.09005 8.51837 7.90971 8.51837 7.75037 8.44595ZM8.67696 9.08519L8.55929 9.13852C8.38204 9.2189 8.19389 9.25968 8.00004 9.25968C7.80619 9.25968 7.6182 9.2189 7.4408 9.13852L3.65271 7.42128L2.29089 8.03838C1.90304 8.21415 1.90304 8.80008 2.29089 8.97586L7.75037 11.4506C7.90971 11.5228 8.09005 11.5228 8.24939 11.4506L9.17956 11.029V10.3225C9.11967 10.2481 9.06384 10.1698 9.01225 10.0878C8.81352 9.77158 8.70837 9.429 8.67696 9.08519ZM9.17956 11.8573L8.55929 12.1385C8.38204 12.2189 8.19389 12.2596 8.00004 12.2596C7.80619 12.2596 7.6182 12.2189 7.4408 12.1385L3.6475 10.4189L2.29089 11.0337C1.90304 11.2094 1.90304 11.7953 2.29089 11.9711L7.75037 14.4459C7.90971 14.518 8.09005 14.518 8.24939 14.4459L8.78015 14.2053C8.70528 13.974 8.66671 13.7289 8.66671 13.4744C8.66671 13.0554 8.7699 12.6354 9.0033 12.2534C9.02917 12.2111 9.05619 12.1697 9.08435 12.1293C9.11479 12.0856 9.14652 12.043 9.17956 12.0016V11.8573Z" fill="#4B5675"/>
                    <path d="M11.0256 14.5C10.7436 14.5 10.5021 14.3996 10.3013 14.1987C10.1004 13.9979 10 13.7564 10 13.4744C10 13.2778 10.047 13.1026 10.141 12.9487C10.235 12.7949 10.359 12.6709 10.5128 12.5769V9.74359C10.359 9.64957 10.235 9.52778 10.141 9.37821C10.047 9.22863 10 9.05556 10 8.85897C10 8.57692 10.1004 8.33547 10.3013 8.13462C10.5021 7.93376 10.7436 7.83333 11.0256 7.83333C11.3077 7.83333 11.5491 7.93376 11.75 8.13462C11.9509 8.33547 12.0513 8.57692 12.0513 8.85897C12.0513 9.05556 12.0043 9.22863 11.9103 9.37821C11.8162 9.52778 11.6923 9.64957 11.5385 9.74359V11.2179L13.5897 10.5385V9.74359C13.4359 9.64957 13.312 9.52778 13.2179 9.37821C13.1239 9.22863 13.0769 9.05556 13.0769 8.85897C13.0769 8.57692 13.1773 8.33547 13.3782 8.13462C13.5791 7.93376 13.8205 7.83333 14.1026 7.83333C14.3846 7.83333 14.6261 7.93376 14.8269 8.13462C15.0278 8.33547 15.1282 8.57692 15.1282 8.85897C15.1282 9.05556 15.0812 9.22863 14.9872 9.37821C14.8932 9.52778 14.7692 9.64957 14.6154 9.74359V10.5256C14.6154 10.7479 14.5513 10.9487 14.4231 11.1282C14.2949 11.3077 14.1239 11.4316 13.9103 11.5L11.5385 12.2949V12.5769C11.6923 12.6709 11.8162 12.7949 11.9103 12.9487C12.0043 13.1026 12.0513 13.2778 12.0513 13.4744C12.0513 13.7564 11.9509 13.9979 11.75 14.1987C11.5491 14.3996 11.3077 14.5 11.0256 14.5Z" fill="#4B5675"/>
                    </svg>
                    {selectedCounts.Partition}</span> {"]"}</div></div>
                )}
                 {this.props.type === "Attribute Group" && selectedCounts.Attribute > 0 && (
                  <div className="mx-1" style={{ marginLeft: "10px" }}><div className="tree-nodes-enabled-count mr-1">{"["} <span className="text-blue"><FontAwesomeIcon icon={this.getIcon("Attribute")} style={{ marginRight: "4px" }}/>{selectedCounts.Attribute}</span> {"]"}</div></div>
                )}
                {this.props.type === "Partition" && selectedCounts.PartitionAttribute > 0 && (
                 <div className="mx-1"style={{ marginLeft: "10px" }} ><div className="tree-nodes-enabled-count mr-1">{"["} <span className="text-blue"><FontAwesomeIcon icon={this.getIcon("Attribute")} style={{ marginRight: "4px" }}/>{selectedCounts.PartitionAttribute}</span> {"]"}</div></div>
                )}
              </>
            )}
          </div>
          
          { this.state.isNodeHasActions   && childNodes.length === 0  && type !== "Dataset" && type !== "Datasource"? 
          <div className="qd_tree-actions">
            <span className="performance-stats">
              {this.props.arrowIndicator === true && latest !== previous && <span className="svg-icon">
                {previous === "NA" || latest > previous ? (
                 <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M6.93056 2.2207C7.01867 2.2207 7.1037 2.23629 7.18565 2.26746C7.26759 2.29863 7.3416 2.34726 7.40769 2.41335L10.3074 5.31302C10.4358 5.44145 10.5 5.60049 10.5 5.79014C10.5 5.9798 10.4358 6.13884 10.3074 6.26727C10.1752 6.40429 10.0152 6.47186 9.82743 6.46999C9.63964 6.46812 9.48154 6.40055 9.35312 6.26727L7.61321 4.53297L7.61321 12.0381C7.61321 12.2277 7.54685 12.3889 7.41413 12.5216C7.2814 12.6543 7.12021 12.7207 6.93056 12.7207C6.74091 12.7207 6.57972 12.6543 6.44699 12.5216C6.31427 12.3889 6.24791 12.2277 6.24791 12.0381L6.24791 4.53297L4.51361 6.26727C4.37659 6.40429 4.2154 6.47279 4.03004 6.47279C3.84468 6.47279 3.68349 6.40429 3.54648 6.26727C3.41319 6.13025 3.34777 5.96906 3.3502 5.7837C3.35263 5.59834 3.41805 5.44145 3.54648 5.31302L6.44616 2.41335C6.51224 2.34727 6.58747 2.29864 6.67184 2.26746C6.75621 2.23629 6.84245 2.2207 6.93056 2.2207Z" fill="#198754"/>
                 </svg>                 
                 ) : 
                 <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M6.93056 12.7188C7.01867 12.7188 7.1037 12.7032 7.18565 12.672C7.26759 12.6408 7.3416 12.5922 7.40769 12.5261L10.3074 9.62644C10.4358 9.49801 10.5 9.33896 10.5 9.14931C10.5 8.95966 10.4358 8.80061 10.3074 8.67218C10.1752 8.53517 10.0152 8.46759 9.82743 8.46947C9.63964 8.47133 9.48154 8.5389 9.35312 8.67218L7.61321 10.4065L7.61321 2.9014C7.61321 2.71175 7.54685 2.55056 7.41413 2.41784C7.2814 2.28511 7.12021 2.21875 6.93056 2.21875C6.74091 2.21875 6.57972 2.28511 6.44699 2.41784C6.31427 2.55056 6.24791 2.71175 6.24791 2.9014L6.24791 10.4065L4.51361 8.67218C4.37659 8.53517 4.2154 8.46666 4.03004 8.46666C3.84468 8.46666 3.68349 8.53517 3.54648 8.67218C3.41319 8.8092 3.34777 8.97039 3.3502 9.15575C3.35263 9.34111 3.41805 9.49801 3.54648 9.62644L6.44616 12.5261C6.51224 12.5922 6.58747 12.6408 6.67184 12.672C6.75621 12.7032 6.84245 12.7188 6.93056 12.7188Z" fill="#F64E60"/>
                 </svg>}
              </span>
              }
              {this.props.newValue === true && <span className="new-stat">{this.formatValue(latest)}</span>}
              {this.props.oldValue === true && <span className="old-stat">{this.formatValue(previous)}</span>}
            </span>
          </div> : ''}  
        </div> 
        
          {/* {this.props.inProgress === true
          ?
            <Image className="spinner-img" src="spinner" />
          :
            ""
        } */}
            </>
        : 
        <>
        <div className={childNodes.length === 0  ? "": (this.props.watchListOpen !== true ? (this.state.isOpen ? "caret caret-down" : "caret"):"")} onClick={this.props.watchListOpen !== true ? this.toggle:this.toggleForWatchlistOpen}>
          <div className="qd_tree-label">
            {this.state.showCustomCheckbox ? (
              disabledCheckboxTooltip ? (
                <Tooltip placement="top" overlay={disabledCheckboxTooltip} trigger={["hover"]}>
                  <span style={{ display: "inline-block" }}>
                    <input
                      type="checkbox"
                      id={uniqueId}
                      disabled={!isAttributeActionAllowed}
                      style={attributeCheckboxStyle}
                      onChange={(event) => {
                        if (!isAttributeActionAllowed) {
                          event.preventDefault();
                          return;
                        }
                        this.props.handleSaveWatchlistCheckboxChange(event, type, uniqueId, this.props.childNodes);
                      }}
                      checked={this.props.checkedStates[getNodeKey(this.props.type, this.props.id)]?.checked || false}
                      className="mr-2"
                    />
                  </span>
                </Tooltip>
              ) : (
                <input
                  type="checkbox"
                  id={uniqueId}
                  disabled={!isAttributeActionAllowed}
                  style={attributeCheckboxStyle}
                  onChange={(event) => {
                    if (!isAttributeActionAllowed) {
                      event.preventDefault();
                      return;
                    }
                    this.props.handleSaveWatchlistCheckboxChange(event, type, uniqueId, this.props.childNodes);
                  }}
                  checked={this.props.checkedStates[getNodeKey(this.props.type, this.props.id)]?.checked || false}
                  className="mr-2"
                />
              )
            ) : null}
            <span onClick={this.toggle} className={this.state.isShow ? (this.state.highlightedClass !== "" ? this.state.highlightedClass : (this.props.subString ? "" : "search-highlight1")) : ""}>
              <i>  
                {type === "Metrics"?<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginRight: "4px" }}>
<path d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM5.33333 6.66667C5.14444 6.66667 4.98611 6.73056 4.85833 6.85833C4.73056 6.98611 4.66667 7.14444 4.66667 7.33333V10.6667C4.66667 10.8556 4.73056 11.0139 4.85833 11.1417C4.98611 11.2694 5.14444 11.3333 5.33333 11.3333C5.52222 11.3333 5.68056 11.2694 5.80833 11.1417C5.93611 11.0139 6 10.8556 6 10.6667V7.33333C6 7.14444 5.93611 6.98611 5.80833 6.85833C5.68056 6.73056 5.52222 6.66667 5.33333 6.66667ZM8 4.66667C7.81111 4.66667 7.65278 4.73056 7.525 4.85833C7.39722 4.98611 7.33333 5.14444 7.33333 5.33333V10.6667C7.33333 10.8556 7.39722 11.0139 7.525 11.1417C7.65278 11.2694 7.81111 11.3333 8 11.3333C8.18889 11.3333 8.34722 11.2694 8.475 11.1417C8.60278 11.0139 8.66667 10.8556 8.66667 10.6667V5.33333C8.66667 5.14444 8.60278 4.98611 8.475 4.85833C8.34722 4.73056 8.18889 4.66667 8 4.66667ZM10.6667 8.66667C10.4778 8.66667 10.3194 8.73056 10.1917 8.85833C10.0639 8.98611 10 9.14444 10 9.33333V10.6667C10 10.8556 10.0639 11.0139 10.1917 11.1417C10.3194 11.2694 10.4778 11.3333 10.6667 11.3333C10.8556 11.3333 11.0139 11.2694 11.1417 11.1417C11.2694 11.0139 11.3333 10.8556 11.3333 10.6667V9.33333C11.3333 9.14444 11.2694 8.98611 11.1417 8.85833C11.0139 8.73056 10.8556 8.66667 10.6667 8.66667Z" fill="currentColor"/>
</svg> : (type === "CustomMetrics" ? <Image src="icon_insert_setting_chart"/>
              :type ? (
                <FontAwesomeIcon icon={this.getIcon(type)} />
              ) : (
                <span>{getIconforMetrics(title)}</span>
              ))}
              {this.props.error && <sup>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.26392C5.14167 7.26392 5.26042 7.21751 5.35625 7.1247C5.45208 7.03188 5.5 6.91687 5.5 6.77966C5.5 6.64245 5.45208 6.52744 5.35625 6.43462C5.26042 6.34181 5.14167 6.2954 5 6.2954C4.85833 6.2954 4.73958 6.34181 4.64375 6.43462C4.54792 6.52744 4.5 6.64245 4.5 6.77966C4.5 6.91687 4.54792 7.03188 4.64375 7.1247C4.73958 7.21751 4.85833 7.26392 5 7.26392ZM5 5.32688C5.14167 5.32688 5.26042 5.28047 5.35625 5.18765C5.45208 5.09483 5.5 4.97982 5.5 4.84262V2.90557C5.5 2.76836 5.45208 2.65335 5.35625 2.56053C5.26042 2.46772 5.14167 2.42131 5 2.42131C4.85833 2.42131 4.73958 2.46772 4.64375 2.56053C4.54792 2.65335 4.5 2.76836 4.5 2.90557V4.84262C4.5 4.97982 4.54792 5.09483 4.64375 5.18765C4.73958 5.28047 4.85833 5.32688 5 5.32688ZM5 9.68523C4.30833 9.68523 3.65833 9.55811 3.05 9.30387C2.44167 9.04964 1.9125 8.7046 1.4625 8.26877C1.0125 7.83293 0.65625 7.32042 0.39375 6.73124C0.13125 6.14205 0 5.51251 0 4.84262C0 4.17272 0.13125 3.54318 0.39375 2.95399C0.65625 2.36481 1.0125 1.8523 1.4625 1.41646C1.9125 0.98063 2.44167 0.635593 3.05 0.381356C3.65833 0.127119 4.30833 0 5 0C5.69167 0 6.34167 0.127119 6.95 0.381356C7.55833 0.635593 8.0875 0.98063 8.5375 1.41646C8.9875 1.8523 9.34375 2.36481 9.60625 2.95399C9.86875 3.54318 10 4.17272 10 4.84262C10 5.51251 9.86875 6.14205 9.60625 6.73124C9.34375 7.32042 8.9875 7.83293 8.5375 8.26877C8.0875 8.7046 7.55833 9.04964 6.95 9.30387C6.34167 9.55811 5.69167 9.68523 5 9.68523Z" fill="#F64E60"/>
                </svg>
              </sup>}
              </i>
              <span>{this.props.subString ? this.getHighlightedText(title, this.props.subString) : title}</span> 
            </span> 
            {/* Add this partition counter */}
            {/* <div className="mx-1"><div className="tree-nodes-enabled-count mr-1">{"["} <span className="text-blue"><FontAwesomeIcon icon={faLayerGroup} /> 1</span> {"]"}</div></div> */}
          </div>
          { this.state.isNodeHasActions && childNodes.length ===0 && type !== "Attribute"? 
          <div className="qd_tree-actions">
            <span className="performance-stats">
              {this.state.arrowIndicator === true && latest !== previous &&  <span className="svg-icon">
                {previous === "NA" || latest > previous ? (
                 <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M6.93056 2.2207C7.01867 2.2207 7.1037 2.23629 7.18565 2.26746C7.26759 2.29863 7.3416 2.34726 7.40769 2.41335L10.3074 5.31302C10.4358 5.44145 10.5 5.60049 10.5 5.79014C10.5 5.9798 10.4358 6.13884 10.3074 6.26727C10.1752 6.40429 10.0152 6.47186 9.82743 6.46999C9.63964 6.46812 9.48154 6.40055 9.35312 6.26727L7.61321 4.53297L7.61321 12.0381C7.61321 12.2277 7.54685 12.3889 7.41413 12.5216C7.2814 12.6543 7.12021 12.7207 6.93056 12.7207C6.74091 12.7207 6.57972 12.6543 6.44699 12.5216C6.31427 12.3889 6.24791 12.2277 6.24791 12.0381L6.24791 4.53297L4.51361 6.26727C4.37659 6.40429 4.2154 6.47279 4.03004 6.47279C3.84468 6.47279 3.68349 6.40429 3.54648 6.26727C3.41319 6.13025 3.34777 5.96906 3.3502 5.7837C3.35263 5.59834 3.41805 5.44145 3.54648 5.31302L6.44616 2.41335C6.51224 2.34727 6.58747 2.29864 6.67184 2.26746C6.75621 2.23629 6.84245 2.2207 6.93056 2.2207Z" fill="#198754"/>
                 </svg> )
                  : 
                  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.93056 12.7188C7.01867 12.7188 7.1037 12.7032 7.18565 12.672C7.26759 12.6408 7.3416 12.5922 7.40769 12.5261L10.3074 9.62644C10.4358 9.49801 10.5 9.33896 10.5 9.14931C10.5 8.95966 10.4358 8.80061 10.3074 8.67218C10.1752 8.53517 10.0152 8.46759 9.82743 8.46947C9.63964 8.47133 9.48154 8.5389 9.35312 8.67218L7.61321 10.4065L7.61321 2.9014C7.61321 2.71175 7.54685 2.55056 7.41413 2.41784C7.2814 2.28511 7.12021 2.21875 6.93056 2.21875C6.74091 2.21875 6.57972 2.28511 6.44699 2.41784C6.31427 2.55056 6.24791 2.71175 6.24791 2.9014L6.24791 10.4065L4.51361 8.67218C4.37659 8.53517 4.2154 8.46666 4.03004 8.46666C3.84468 8.46666 3.68349 8.53517 3.54648 8.67218C3.41319 8.8092 3.34777 8.97039 3.3502 9.15575C3.35263 9.34111 3.41805 9.49801 3.54648 9.62644L6.44616 12.5261C6.51224 12.5922 6.58747 12.6408 6.67184 12.672C6.75621 12.7032 6.84245 12.7188 6.93056 12.7188Z" fill="#F64E60"/>
                  </svg>}
              </span>}
              {this.state.newValue === true && <span className="new-stat">{latest}</span>}
              {this.state.oldValue === true && <span className="old-stat">{previous}</span>}
            </span>
          </div> : ''}  
        </div>
     
        </>}
        {childNodes.length > 0 && (((childrenLength.length > 0 || !this.props.isRedirect) && this.state.isOpen) || (["Environment", "Datasource"].includes(type) && !(this.state.isChanged) && this.props.isSearchHappened)) && (
          <ul className={ulClassName}>
            {childNodes.map(({ id, title, childNodes, type, isOpen, isShow,metrics,customMetrics,latest,previous,error,firstDataset,is_disabled }) => ( 
              isShow || !this.props.isRedirect || (["Environment", "Datasource"].includes(type) && this.props.isSearchHappened && !(this.state.isChanged)) ? <Node key={title || this.props.id}
                title={title}
                id={id}
                changeData={this.props.changeData}
                isSearchHappened={this.props.isSearchHappened}
                isTreeSearch={this.props.isTreeSearch}
                envName={this.state.envName}
                envId={this.state.envId}
                isRedirect={this.props.isRedirect}
                highlightedType={this.state.highlightedType}
                highlightedId={this.state.highlightedId}
                datasourceName={this.state.datasourceName}
                datasetName={this.state.datasetName}
                attributeName={this.state.attributeName}
                datasourceId={this.state.datasourceId}
                datasetId={this.state.datasetId}
                attributeId={this.state.attributeId}
                childNodes={childNodes !== undefined ? Object.values(childNodes) : []}
                type={type} 
                isOpen={firstDataset || this.state.isOpen}  // Ensure firstDataset is always open
                subString={this.props.subString}
                isShow={isShow}
                isNodeHasActions = {this.props.isNodeHasActions}
                showCustomCheckbox={this.state.showCustomCheckbox}
                isChanged={this.state.isChanged}
                isChecked={this.props.isChecked}  
                handleCheckboxChange={this.props.handleCheckboxChange}
                arrowIndicator={this.props.arrowIndicator}
                newValue = {this.props.newValue}
                oldValue = {this.props.oldValue}
                latest ={latest}
                previous={previous}
                is_disabled ={is_disabled}
                error = {error}
                firstDataset={firstDataset}
                handleSaveWatchlistCheckboxChange ={this.props.handleSaveWatchlistCheckboxChange}
                checkedStates={this.props.checkedStates}
                metrics={metrics}
                customMetrics={customMetrics}
                watchListOpen={this.props.watchListOpen}
                inProgress = {this.props.inProgress}
                selectPartitionButton = {this.props.selectPartitionButton}
                clearCheckedStates = {this.props.clearCheckedStates}
                saveWatchListSearchText ={this.props.saveWatchListSearchText}
                isPartitionChecked = {this.props.isPartitionChecked}
                noDatasetFound = {this.props.noDatasetFound}
                selectedWatchlistId = {this.props.selectedWatchlistId}
                getMetricsValueResponse = {this.props.getMetricsValueResponse}





/> : ""
            ))}
          </ul>

        )}
      </li>
    );
  }
}
